<template>
    <!-- Wallet Card -->
    <div class="section pt-1">
        <div class="wallet-card">
            <!-- Balance -->
            <div class="balance">
                <div class="left">
                    <span class="title mal-text">ടാർഗറ്റ്</span>
                    <h1 class="total text-primary">₹{{ target?target.toFixed(2):'0.00' }}</h1>
                </div>
                <div class="right" v-if="showAddButton">
                    <a href="javascript:void(0);" class="button" @click="adminAdd">
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="section">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">കിട്ടിയത്</div>
                    <div class="value text-success">₹{{ total.toFixed(2) }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ബാക്കിയുള്ളത്</div>
                    <div class="value text-danger">₹{{ minusToZero ? minusToZero : '00.0' }}</div>
                </div>
            </div>
            <template v-if="user_level < 3 || is_youth_dawa_fund">
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">സ്റ്റേറ്റ് വിഹിതം</div>
                        <div class="value text-warning">₹{{ getPercentage(target?target:0,total,1) }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">ശാഖാ വിഹിതം</div>
                        <div class="value text-info">₹{{ getPercentage(target?target:0,total,4) }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">മണ്ഡലം വിഹിതം</div>
                        <div class="value text-secondary">₹{{ getPercentage(target?target:0,total,3) }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">ജില്ല വിഹിതം</div>
                        <div class="value text-primary">₹{{ getPercentage(target?target:0,total,2) }}</div>
                    </div>
                </div>
            </template>
            <template v-if="is_youth_dawa_fund">
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text" style="font-size:11px;">കാണേണ്ടവരുടെ എണ്ണം</div>
                        <div class="value text-dark">{{ toMeetCount }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text" style="font-size:11px;">കണ്ടവരുടെ എണ്ണം</div>
                        <div class="value text-success">{{ metCount }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <!-- Youth Dawa Fund consolidation/settlement report and the Share Taken/Request Share Fund
         action now live on the Book Take-Back page instead (see BookTakeBack.vue) — keeps this
         main list page focused on the member list. -->
    <!-- Tutorials — Youth Dawa Fund only (for now) -->
    <div v-if="is_youth_dawa_fund" class="section mt-1" style="display:flex;justify-content:flex-end;">
        <tutorial-button category="Youth Dawa Fund" id="ydfUnitTutorialSheet" :level="4" />
    </div>
    <!-- Help Desk -->
    <div class="section mt-1 mb-2">
        <help-desk-card :context="{ district: unit.district_name, zone: unit.zone_name, unit: unit.name }" :show-slip-banner="true" />
    </div>

    <!-- Visit counts modal -->
    <div class="modal fade action-sheet" id="visitCountsModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">{{ visitModalType === 'to_meet' ? 'കാണേണ്ടവർ' : 'കണ്ടവർ' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div v-if="visitModalList.length === 0" class="text-center py-3 mal-text">ആരും ഇല്ല</div>
                        <ul style="list-style:none; margin:0; padding:0;">
                            <li v-for="(item, idx) in visitModalList" :key="idx"
                                style="display:flex; align-items:center; padding:10px 12px; border-bottom:1px solid #f0f0f0;">
                                <span style="font-size:13px; color:#aaa; width:24px; flex-shrink:0;">{{ idx + 1 }}</span>
                                <div style="flex:1; min-width:0;">
                                    <div style="font-weight:600;">{{ item.name || '—' }}</div>
                                    <div style="font-size:13px; color:#888;" v-if="item.mobile">{{ item.country_code }} {{ item.mobile }}</div>
                                </div>
                                <input v-if="visitModalType === 'to_meet'" type="checkbox"
                                    style="width:20px; height:20px; cursor:pointer; flex-shrink:0; margin-left:10px;"
                                    :checked="item.visited"
                                    @change="toggleVisit(item, $event.target.checked)" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Receipt Books allocated to this unit -->
    <div class="section mt-2 mb-1" v-if="is_youth_dawa_fund && receiptBooks.length">
        <div class="rb-header">
            <span class="mal-text rb-section-title">റെസിപ്റ്റ് ബുക്കുകൾ</span>
        </div>
        <div class="receipt-book-grid">
            <div class="receipt-book-card" v-for="book in receiptBooks" :key="book.id"
                :class="book.received ? 'received' : 'pending'">
                <!-- Row 1: icon + book info + status badge -->
                <div class="rb-row1">
                    <ion-icon name="book-outline" class="rb-icon"></ion-icon>
                    <div class="rb-info">
                        <span class="rb-title">Book {{ book.book_number }}</span>
                        <span class="rb-range" v-if="book.receipt_from">{{ book.receipt_from }} – {{ book.receipt_to }}</span>
                    </div>
                    <span v-if="book.received" class="rb-badge received-badge">
                        <ion-icon name="checkmark-circle-outline"></ion-icon> Received
                    </span>
                    <button v-else type="button" class="rb-receive-btn"
                        @click="markBookReceivedConfirmation(book)">
                        <ion-icon name="checkmark-outline"></ion-icon> Mark Received
                    </button>
                    <button type="button" class="rb-timeline-btn" title="Timeline"
                        @click="openBookTimeline(book)">
                        <ion-icon name="time-outline"></ion-icon>
                    </button>
                </div>
                <!-- Row 2: holder name with edit, or assign button if no holder (admin only) -->
                <div v-if="book.holder_name" class="rb-holder">
                    <ion-icon name="person-outline"></ion-icon>
                    <span style="flex:1;min-width:0;">{{ book.holder_name }}</span>
                    <button v-if="book.received && book.holder_member_id == currentUser.member_id" type="button"
                        class="rb-edit-holder-btn" @click="openChangeHolderModal(book)"
                        title="ചുമതലക്കാരനെ മാറ്റുക">
                        <ion-icon name="pencil-outline"></ion-icon>
                    </button>
                </div>
                <div v-else-if="permissions.update" class="rb-holder"
                    style="cursor:pointer;border:1px dashed #b0b8d0;border-radius:6px;background:#f5f7fc;"
                    @click="openChangeHolderModal(book)">
                    <ion-icon name="person-add-outline" style="color:#6b7fa3;font-size:16px;flex-shrink:0;"></ion-icon>
                    <span style="flex:1;color:#6b7fa3;font-size:13px;">ചുമതലക്കാരനെ ചേർക്കുക</span>
                </div>
            </div>
        </div>
    </div>
    <!-- All books verified and handed back to the zone — unit is closed out, no more entries. -->
    <div class="section mt-1 mb-1" v-if="allBooksTakenBack">
        <div class="ydf-takeback-btn" style="background:#eafaf1;border-color:#c8f0d8;">
            <span class="ydf-takeback-icon" style="background:#d3f5e2;color:#12a85a;">
                <ion-icon name="checkmark-done-circle-outline"></ion-icon>
            </span>
            <span class="ydf-takeback-body">
                <span class="ydf-takeback-title mal-text">എല്ലാ ബുക്കുകളും വെരിഫൈ ചെയ്തു</span>
                <span class="ydf-takeback-desc mal-text">ബുക്ക് മണ്ഡലത്തിന് കൈമാറി</span>
            </span>
        </div>
    </div>
    <!-- Book Taking Back — state and district admins (backend already permits both
         unconditionally), plus the zone admin this unit belongs to (backend's
         canAccessTakeBack() already scopes a zone admin to their own zone's units). -->
    <div class="section mt-1 mb-1" v-if="is_youth_dawa_fund && currentUser && currentUser.user_level <= 3">
        <router-link
            :to="'/org/' + $route.params.sub_level + '/' + $route.params.id + '/fund-collection/' + $route.params.type + '/book-takeback'"
            class="ydf-takeback-btn">
            <span class="ydf-takeback-icon"><ion-icon name="reader-outline"></ion-icon></span>
            <span class="ydf-takeback-body">
                <span class="ydf-takeback-title mal-text">ബുക്ക് തിരിച്ചെടുക്കൽ</span>
                <span class="ydf-takeback-desc mal-text">ബുക്ക് വെരിഫൈ ചെയ്ത് തിരിച്ചെടുക്കാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
                <span class="ydf-takeback-badge badge-pending" v-if="latestShareRequestStatus && latestShareRequestStatus.status === 'pending'">⏳ റിക്വസ്റ്റ് അയച്ചു</span>
                <span class="ydf-takeback-badge badge-accepted" v-else-if="latestShareRequestStatus && latestShareRequestStatus.status === 'approved' && !latestShareRequestStatus.received_status">✓ മണ്ഡലം അംഗീകരിച്ചു</span>
                <span class="ydf-takeback-badge badge-rejected" v-else-if="latestShareRequestStatus && latestShareRequestStatus.status === 'rejected'">✗ റിക്വസ്റ്റ് നിരസിച്ചു</span>
                <span class="ydf-takeback-badge badge-accepted" v-else-if="settlementStatus && settlementStatus.share_taken_status === 'accepted'">✓ വിഹിതം അയച്ചു</span>
                <span class="ydf-takeback-badge badge-pending" v-else-if="settlementStatus && settlementStatus.share_taken_status === 'pending'">⏳ അവലോകനത്തിൽ</span>
                <span class="ydf-takeback-badge badge-rejected" v-else-if="settlementStatus && settlementStatus.share_taken_status === 'rejected'">✗ നിരസിച്ചു</span>
            </span>
            <ion-icon name="chevron-forward-outline" class="ydf-takeback-chevron"></ion-icon>
        </router-link>
    </div>
    <!-- Request Share Fund / Mark Share Taken — same real-money settlement actions as the Book
         Take-Back / Financial Report page (see BookTakeBack.vue, HighLevelReport.vue),
         duplicated here so this level's own dashboard is directly actionable without a
         click-through. Works the same way at every level (unit/zone/district): once this
         level's own figures are final (readyForShareAction), either a shortfall needs
         requesting from the level above, or the share-taken declaration needs making/tracking. -->
    <div class="section mt-1 mb-1" v-if="is_youth_dawa_fund && currentUser && currentUser.user_level <= 3 && readyForShareAction && settlementStatus">
        <button type="button" class="ydf-takeback-btn" v-if="settlementStatus.shortfall > 0 && !moneyEffectivelyReceived" @click="openRequestShareModal">
            <span class="ydf-takeback-icon"><ion-icon name="cash-outline"></ion-icon></span>
            <span class="ydf-takeback-body">
                <span class="ydf-takeback-title mal-text">{{ requestShareFromLabel }} നിന്ന് വിഹിതം റിക്വസ്റ്റ് ചെയ്യുക</span>
                <span class="ydf-takeback-desc mal-text">₹{{ formatAmt(settlementStatus.shortfall) }} കുറവുണ്ട്</span>
            </span>
            <ion-icon name="chevron-forward-outline" class="ydf-takeback-chevron"></ion-icon>
        </button>
        <template v-else>
            <div class="share-taken-card" :class="'status-' + settlementStatus.share_taken_status" v-if="settlementStatus.share_taken_at">
                <span class="share-taken-icon">
                    <ion-icon v-if="settlementStatus.share_taken_status === 'accepted'" name="checkmark-circle-outline"></ion-icon>
                    <ion-icon v-else-if="settlementStatus.share_taken_status === 'rejected'" name="close-circle-outline"></ion-icon>
                    <ion-icon v-else name="time-outline"></ion-icon>
                </span>
                <span class="ydf-takeback-body">
                    <span class="ydf-takeback-title mal-text">
                        <template v-if="settlementStatus.share_taken_status === 'accepted'">വിഹിതം എടുത്തു, ബാക്കി തുക {{ requestShareToLabel }} അയച്ചു — അംഗീകരിച്ചു</template>
                        <template v-else-if="settlementStatus.share_taken_status === 'rejected'">നിരസിച്ചു</template>
                        <template v-else>അവലോകനത്തിലാണ്</template>
                    </span>
                    <span class="ydf-takeback-desc mal-text">{{ settlementStatus.share_taken_by_name }} &middot; {{ settlementStatus.share_taken_at }}</span>
                    <span class="ydf-takeback-desc mal-text" style="color:#c0392b;" v-if="settlementStatus.share_taken_status === 'rejected' && settlementStatus.share_taken_rejection_reason">
                        കാരണം: {{ settlementStatus.share_taken_rejection_reason }}
                    </span>
                </span>
                <button type="button" class="btn btn-sm btn-outline-danger mal-text" v-if="settlementStatus.share_taken_status === 'pending'" :disabled="shareTakenSaving" @click="cancelShareTakenAction">റദ്ദാക്കുക</button>
                <button type="button" class="btn btn-sm btn-outline-primary mal-text" v-if="settlementStatus.share_taken_status === 'rejected'" :disabled="shareTakenSaving" @click="confirmMarkShareTaken">വീണ്ടും ശ്രമിക്കുക</button>
            </div>
            <button type="button" class="ydf-takeback-btn" v-else :disabled="shareTakenSaving" @click="confirmMarkShareTaken">
                <span class="ydf-takeback-icon"><ion-icon name="checkmark-done-outline"></ion-icon></span>
                <span class="ydf-takeback-body">
                    <span class="ydf-takeback-title mal-text">വിഹിതം എടുത്തു, ബാക്കി തുക {{ requestShareToLabel }} അയച്ചു</span>
                    <span class="ydf-takeback-desc mal-text">ക്യാഷിൽ നിന്ന് വിഹിതം എടുത്ത് ബാക്കി {{ requestShareToLabel }} കൈമാറിയെങ്കിൽ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
                </span>
            </button>
        </template>
    </div>

    <!-- Request Share Fund Modal — copied from BookTakeBack.vue's #requestShareFundModal so the
         button above can act without navigating away. -->
    <div class="modal fade action-sheet" id="requestShareFundModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">{{ requestShareFromLabel }} നിന്ന് വിഹിതം റിക്വസ്റ്റ് ചെയ്യുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="input-wrapper">
                            <label class="label" for="unit_dash_request_share_amount"><span>തുക</span></label>
                            <input type="number" id="unit_dash_request_share_amount" class="form-control" v-model="requestShareAmount" placeholder="₹0.00">
                        </div>
                        <div class="input-wrapper mt-2">
                            <label class="label" for="unit_dash_request_share_reason"><span>കാരണം <em>(optional)</em></span></label>
                            <input type="text" id="unit_dash_request_share_reason" class="form-control" v-model="requestShareReason" placeholder="Reason">
                        </div>
                        <div class="mt-2">
                            <label class="label"><span>പണം ലഭിക്കേണ്ടത്</span></label>
                            <div style="display:flex;gap:8px;">
                                <button type="button" class="btn btn-sm" :class="requestSharePaymentMethod === 'upi' ? 'btn-primary' : 'btn-outline-secondary'" @click="requestSharePaymentMethod = 'upi'">UPI</button>
                                <button type="button" class="btn btn-sm" :class="requestSharePaymentMethod === 'bank' ? 'btn-primary' : 'btn-outline-secondary'" @click="requestSharePaymentMethod = 'bank'">Bank Account</button>
                            </div>
                        </div>
                        <template v-if="requestSharePaymentMethod === 'upi'">
                            <div class="input-wrapper mt-2">
                                <label class="label" for="unit_dash_request_share_upi"><span>UPI ഐഡി <em>(optional)</em></span></label>
                                <input type="text" id="unit_dash_request_share_upi" class="form-control" v-model="requestShareUpiId" placeholder="name@bank">
                            </div>
                            <p class="mal-text" style="font-size:12px;color:#6c757d;margin:8px 0 0;">അല്ലെങ്കിൽ ഗൂഗിൾ പേ വഴി:</p>
                            <div class="input-wrapper mt-2">
                                <label class="label" for="unit_dash_request_share_gpay_mobile"><span>ഗൂഗിൾ പേ മൊബൈൽ നമ്പർ</span></label>
                                <input type="text" id="unit_dash_request_share_gpay_mobile" class="form-control" v-model="requestShareGpayMobile" placeholder="Mobile number">
                            </div>
                            <div class="input-wrapper mt-2">
                                <label class="label" for="unit_dash_request_share_gpay_name"><span>ഗൂഗിൾ പേ അക്കൗണ്ട് ഹോൾഡറുടെ പേര്</span></label>
                                <input type="text" id="unit_dash_request_share_gpay_name" class="form-control" v-model="requestShareGpayName" placeholder="Account holder name">
                            </div>
                        </template>
                        <template v-else>
                            <div class="input-wrapper mt-2">
                                <label class="label" for="unit_dash_request_share_holder"><span>അക്കൗണ്ട് ഹോൾഡറുടെ പേര്</span></label>
                                <input type="text" id="unit_dash_request_share_holder" class="form-control" v-model="requestShareAccountHolderName" placeholder="Account holder name">
                            </div>
                            <div class="input-wrapper mt-2">
                                <label class="label" for="unit_dash_request_share_account"><span>അക്കൗണ്ട് നമ്പർ</span></label>
                                <input type="text" id="unit_dash_request_share_account" class="form-control" v-model="requestShareAccountNumber" placeholder="Account number">
                            </div>
                            <div class="input-wrapper mt-2">
                                <label class="label" for="unit_dash_request_share_ifsc"><span>IFSC കോഡ്</span></label>
                                <input type="text" id="unit_dash_request_share_ifsc" class="form-control" v-model="requestShareIfscCode" placeholder="IFSC code">
                            </div>
                        </template>
                        <p class="error-feedback" v-if="requestShareMsg">{{ requestShareMsg }}</p>
                        <button type="button" class="btn btn-primary btn-block btn-lg mt-2" :disabled="requestShareSaving" @click="submitShareFundRequest">
                            <span v-if="requestShareSaving" class="spinner-border spinner-border-sm me-1"></span>
                            റിക്വസ്റ്റ് അയക്കുക
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Karad / FFR buttons — Youth Dawa Fund only -->
    <div class="section mt-1 mb-1" v-if="is_youth_dawa_fund">
        <div class="d-flex gap-2">
            <router-link
                :to="'/org/' + $route.params.sub_level + '/' + $route.params.id + '/fund-collection/' + $route.params.type + '/karad-list'"
                class="btn btn-sm btn-outline-primary flex-fill mal-text">
                കരട് ലിസ്റ്റ്
            </router-link>
            <button type="button" class="btn btn-sm btn-outline-secondary flex-fill" disabled>
                FFR List
            </button>
        </div>
    </div>
    <!-- Wallet Card -->
    <!-- <div class="section pt-2">
                                                                        <div class="wallet-card mt-1" v-if="currentUser.user_level <= 4">
                                                                            <div class="wallet-footer wallet-footer-user row">
                                                                                <div class="item col-12">
                                                                                    <a href="javascript:void(0)" @click="adminAdd">
                                                                                        <div class="icon-wrapper back-color-blue1">
                                                                                            <ion-icon name="add-outline"></ion-icon>
                                                                                            <strong class="menu-title mal-text">നേർപഥം ചേർക്കാൻ ഇവിടെ അമർത്തുക</strong>
                                                                                        </div>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> -->
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">{{unit.list_title}}</h3>
            <div class="mt-2 list-actions-row" v-if="listYear === currentYear || showDisableAddButton || showStatePaymentButton">
                <div class="list-actions-left" v-if="!is_youth_dawa_fund && listYear === currentYear">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="showOldList">പഴയ ലിസ്റ്റ്</button>
                </div>
                <div class="list-actions-left" v-else-if="!is_youth_dawa_fund">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="showCurrentList">നിലവിലെ ലിസ്റ്റ്</button>
                </div>
                <div class="list-actions-right" v-if="showDisableAddButton || showStatePaymentButton">
                    <button
                        v-if="showDisableAddButton"
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        @click="disableAddConfirmation"
                    >
                        പുതിയ എൻട്രികൾ നിർത്തുക
                    </button>
                    <button
                        v-else-if="showStatePaymentButton"
                        type="button"
                        class="btn btn-sm btn-outline-success"
                        @click="payStateShare"
                    >
                        സ്റ്റേറ്റ് വിഹിതം അടയ്ക്കുക (₹{{ stateShareAmount.toFixed(2) }})
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Mark Book Received Modal -->
    <div class="modal fade action-sheet" id="receiveBookModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">റസീപ്റ്റ് ബുക്ക് സ്വീകരിക്കൽ</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text">ബുക്ക് നമ്പർ</label>
                                <div style="font-size:16px;font-weight:800;color:#1a418c;padding:4px 0;">Book #{{ receiveBook_number }}</div>
                                <div v-if="receiveBook_from" style="font-size:13px;color:#64748b;margin-top:2px;">
                                    <ion-icon name="receipt-outline" style="vertical-align:middle;margin-right:3px;"></ion-icon>
                                    റസീപ്റ്റ്: <strong>{{ receiveBook_from }}</strong> – <strong>{{ receiveBook_to }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label mal-text">ചുമതലക്കാരൻ</label>
                            <div v-if="receiveBook_selected"
                                style="display:flex;align-items:center;gap:8px;background:#eef3ff;border-radius:8px;padding:8px 12px;margin-bottom:6px;">
                                <div style="flex:1;">
                                    <div style="font-size:13px;font-weight:700;color:#1a418c;">{{ receiveBook_selected.name }}</div>
                                    <div style="font-size:11px;color:#888;">{{ receiveBook_selected.mobile }}</div>
                                </div>
                                <button @click="receiveBook_selected = null; receiveBook_search = ''; receiveBook_holder = ''"
                                    style="background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0;">
                                    <ion-icon name="close-circle-outline"></ion-icon>
                                </button>
                            </div>
                            <div v-else style="position:relative;">
                                <div style="display:flex;gap:6px;align-items:center;">
                                    <input v-model="receiveBook_search" @input="searchReceiveBookMember"
                                        class="form-control"
                                        placeholder="പേര് / മൊബൈൽ തിരയൂ"
                                        style="flex:1;" />
                                    <div v-if="receiveBook_searching" style="padding:0 8px;">
                                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                                    </div>
                                </div>
                                <div v-if="receiveBook_results.length"
                                    style="border:1px solid #ddd;border-radius:8px;margin-top:4px;max-height:150px;overflow-y:auto;background:#fff;position:absolute;width:100%;z-index:999;">
                                    <div v-for="m in receiveBook_results" :key="m.id"
                                        @click="receiveBook_selected = m; receiveBook_holder = m.name; receiveBook_search = m.name; receiveBook_results = []"
                                        style="padding:8px 12px;border-bottom:1px solid #f0f0f0;cursor:pointer;">
                                        <div style="font-size:13px;font-weight:600;color:#27173E;">{{ m.name }}</div>
                                        <div style="font-size:11px;color:#888;">{{ m.mobile }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" class="btn btn-success btn-block btn-lg mal-text"
                                :disabled="receiveBook_saving" @click="submitMarkBookReceived">
                                <span v-if="receiveBook_saving" class="spinner-border spinner-border-sm me-1"></span>
                                ലഭിച്ചതായി confirm ചെയ്യുക
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Change Holder Modal -->
    <div class="modal fade action-sheet" id="changeHolderModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">ചുമതലക്കാരനെ മാറ്റുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text">ബുക്ക് നമ്പർ</label>
                                <div style="font-size:16px;font-weight:800;color:#1a418c;padding:4px 0;">Book #{{ changeHolder_number }}</div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div style="background:#fff7ed;border-left:3px solid #f59e0b;padding:8px 12px;border-radius:0 6px 6px 0;font-size:12px;color:#92400e;line-height:1.5;" class="mal-text">
                                ചുമതലക്കാരനെ മാറ്റിയാൽ ബുക്ക് വീണ്ടും <strong>"ലഭിക്കാത്തത്"</strong> ആകും. പുതിയ ചുമതലക്കാരൻ വീണ്ടും accept ചെയ്യണം.
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label mal-text">പുതിയ ചുമതലക്കാരൻ</label>
                            <div v-if="changeHolder_selected"
                                style="display:flex;align-items:center;gap:8px;background:#eef3ff;border-radius:8px;padding:8px 12px;margin-bottom:6px;">
                                <div style="flex:1;">
                                    <div style="font-size:13px;font-weight:700;color:#1a418c;">{{ changeHolder_selected.name }}</div>
                                    <div style="font-size:11px;color:#888;">{{ changeHolder_selected.mobile }}</div>
                                </div>
                                <button @click="changeHolder_selected = null; changeHolder_search = ''; changeHolder_name = ''"
                                    style="background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0;">
                                    <ion-icon name="close-circle-outline"></ion-icon>
                                </button>
                            </div>
                            <div v-else style="position:relative;">
                                <div style="display:flex;gap:6px;align-items:center;">
                                    <input v-model="changeHolder_search" @input="searchChangeHolderMember"
                                        class="form-control"
                                        placeholder="പേര് / മൊബൈൽ തിരയൂ"
                                        style="flex:1;" />
                                    <div v-if="changeHolder_searching" style="padding:0 8px;">
                                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                                    </div>
                                </div>
                                <div v-if="changeHolder_results.length"
                                    style="border:1px solid #ddd;border-radius:8px;margin-top:4px;max-height:150px;overflow-y:auto;background:#fff;position:absolute;width:100%;z-index:999;">
                                    <div v-for="m in changeHolder_results" :key="m.id"
                                        @click="changeHolder_selected = m; changeHolder_name = m.name; changeHolder_search = m.name; changeHolder_results = []"
                                        style="padding:8px 12px;border-bottom:1px solid #f0f0f0;cursor:pointer;">
                                        <div style="font-size:13px;font-weight:600;color:#27173E;">{{ m.name }}</div>
                                        <div style="font-size:11px;color:#888;">{{ m.mobile }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" class="btn btn-warning btn-block btn-lg mal-text"
                                style="color:#fff;"
                                :disabled="changeHolder_saving || !changeHolder_name" @click="submitChangeHolder">
                                <span v-if="changeHolder_saving" class="spinner-border spinner-border-sm me-1"></span>
                                ചുമതലക്കാരനെ മാറ്റുക
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- AddAdminModel -->
    <div class="modal fade action-sheet" id="addAdminModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">Edit</h5>
                    <h5 class="modal-title" v-if="add_admin">Add New</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAdmin" :validation-schema="schema">
                            <!-- Office (QR) payment toggle — Youth Dawa Fund, new entries only -->
                            <div class="office-toggle" :class="{ active: officeMode }" v-if="is_youth_dawa_fund && add_admin">
                                <label class="office-toggle-row">
                                    <input type="checkbox" v-model="officeMode" />
                                    <span class="office-toggle-text">ഓഫീസ് പേയ്മെന്റ് (QR / ബാങ്ക്)</span>
                                    <ion-icon name="business-outline" class="office-toggle-icon"></ion-icon>
                                </label>
                                <small v-if="officeMode" class="office-toggle-note">
                                    പരിശോധനയ്ക്കായി ചേർക്കുന്നു · ഓഫീസ് വെരിഫൈ ചെയ്താൽ മാത്രമേ രസീത് (T) ജനറേറ്റ് ആകൂ.
                                </small>
                            </div>

                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                    <select as="select" class="form-control custom-select" v-model="isMember" name="isMember" id="select4">
                                        <option value>---Select---</option>
                                        <option value="Y">അതെ</option>
                                        <option value="N">അല്ല</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                            <div class="form-group basic typehead-div" v-if="isMember == 'Y'">
                                <div class="input-wrapper">
                                    <label class="label" for="text4b">Member</label>
                                    <v-select label="text" :filterable="true" v-model="member" :value="member" :options="member_list" @input="getTextList($event.target.value, 0)">
                                        <template>
                                                                                        type to search...
</template>

<template>
    <div class="d-center">
        {{ member.name }}
    </div>
</template>
                                    </v-select>
                                    <ErrorMessage name="member" class="error-feedback" />
                                </div>
                                <div class="input-info" v-if="member">Mobile :{{ member.country_code }} {{
                                        member.mobile
                                }}
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="input-wrapper">
                                    <label class="label" for="name"><span>Name</span></label>
                                    <Field name="name" type="text" class="form-control" v-model="name" :disabled="disable_member_form" placeholder="Name" autocomplete="off" />
                                </div>
                                <ErrorMessage name="name" class="error-feedback" />
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="input-wrapper">
                                    <label class="label" for="mobile"><span>Mobile Number</span></label>
                                    <input type="tel" class="form-control" v-model="mobile" placeholder="Mobile Number" autocomplete="off" />
                                </div>
                            </div>

                            <!-- Office payment proof panel — shown both when adding a new office
                                 payment and when editing one still awaiting office verification -->
                            <div class="office-panel" v-if="officeMode">
                                <div class="office-panel-title">
                                    <ion-icon name="receipt-outline"></ion-icon> പേയ്മെന്റ് തെളിവ്
                                    <em v-if="add_admin" style="color:#dc3545;">*</em>
                                </div>
                                <a v-if="existingSlipUrl && !slipFileName" :href="existingSlipUrl" target="_blank"
                                    class="existing-slip-link">
                                    <ion-icon name="image-outline"></ion-icon> നിലവിലെ സ്ക്രീൻഷോട്ട് കാണുക
                                </a>
                                <label class="upload-box" :class="{ filled: slipFileName }">
                                    <input type="file" accept="image/*,application/pdf" @change="onSlipChange" hidden />
                                    <ion-icon :name="slipFileName ? 'checkmark-circle' : 'cloud-upload-outline'" class="upload-icon"></ion-icon>
                                    <span v-if="!slipFileName" class="upload-text">
                                        {{ existingSlipUrl ? 'മാറ്റാൻ പുതിയ Screenshot upload ചെയ്യുക' : 'Online Transaction ചെയ്ത Screenshot ആണ് ഇവിടെ upload ചെയ്യേണ്ടത്.' }}
                                        <small>image അല്ലെങ്കിൽ PDF<template v-if="add_admin"> (നിർബന്ധം)</template></small>
                                    </span>
                                    <span v-else class="upload-text filled-text">
                                        {{ slipFileName }}
                                        <small>മാറ്റാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക</small>
                                    </span>
                                </label>
                                <div class="office-or"><span>കൂടാതെ</span></div>
                                <div class="input-wrapper">
                                    <label class="label" for="transaction_id"><span>ട്രാൻസാക്ഷൻ ഐഡി <em>(optional)</em></span></label>
                                    <input type="text" class="form-control" v-model="transaction_id" placeholder="Transaction / UTR ID" autocomplete="off" />
                                </div>
                            </div>

                            <div class="form-group basic" v-if="!officeMode">
                                <div class="input-wrapper">
                                    <label class="label" for="receipt_no"><span>Receipt Number</span></label>
                                    <Field v-if="is_youth_dawa_fund" as="select" name="receipt_no"
                                        class="form-control custom-select" v-model="receipt_no">
                                        <option value="">---Select---</option>
                                        <option v-for="n in availableReceiptNumbers" :key="n" :value="n">{{ n }}</option>
                                    </Field>
                                    <Field v-else name="receipt_no" type="text" class="form-control" v-model="receipt_no" placeholder="Receipt Number" autocomplete="off" />
                                </div>
                                <ErrorMessage name="receipt_no" class="error-feedback" />
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="amount"><span>Amount (₹)</span></label>
                                    <Field name="amount" type="number" class="form-control" v-model="amount" placeholder="Amount" autocomplete="off" />
                                </div>
                                <ErrorMessage name="amount" class="error-feedback" />
                            </div>

                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>
    
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading" v-if="permissions.update">
                                                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                                        <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg" v-if="!permissions.update" @click="closeAddAdminModel">Close</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- DeleteMemberModel -->
    
    <div class="section text-center" v-if="loading_list && !bulkMode">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0" v-if="!bulkMode">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല
        </h4>
    </div>

    <!-- Bulk "send branch's cash/personal-account held amount to State" — entry point -->
    <div class="section mt-1" v-if="is_youth_dawa_fund && permissions.update && listYear === currentYear && !loading_list && !bulkMode">
        <button type="button" class="ydf-bulk-entry-btn" @click="openManualBulk">
            <ion-icon name="send-outline"></ion-icon>
            <span class="mal-text">ശാഖയുടെ കൈവശമുള്ള സംഖ്യ സ്റ്റേറ്റ് അക്കൗണ്ടിലേക്ക് അയക്കാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.</span>
        </button>
    </div>

    <!-- Manual entries list (all fetched at once, so selection spans every page) — replaces the main list in place -->
    <div class="section mt-1" v-if="bulkMode">
        <div class="ydf-bulk-header">
            <button type="button" class="btn btn-link btn-icon p-0" @click="closeManualBulk">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </button>
            <span class="mal-text ydf-bulk-header-title">Manual എൻട്രികൾ</span>
        </div>

        <div class="section text-center" v-if="manualBulkLoading">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>
        <template v-else>
            <p class="mal-text text-center" v-if="!manualBulkEntries.length">Manual എൻട്രികൾ ഒന്നും ഇല്ല.</p>
            <template v-else>
                <div class="ydf-bulk-amount-bar" v-if="selectedBulkIds.length">
                    <div class="ydf-bulk-info">
                        <span class="mal-text ydf-bulk-count">{{ selectedBulkIds.length }} എൻട്രി തിരഞ്ഞെടുത്തു</span>
                        <span class="ydf-bulk-amount">₹{{ selectedBulkAmount.toFixed(2) }}</span>
                    </div>
                    <div class="ydf-bulk-section">
                        <a :href="gpayLink" class="ydf-gpay-btn">
                            <ion-icon name="logo-google"></ion-icon>
                            <span>Google Pay വഴി അടയ്ക്കുക</span>
                        </a>
                        <p class="mal-text ydf-upi-choose-label">അല്ലെങ്കിൽ ഈ UPI ഐഡിയിലേക്ക് അടയ്ക്കുക</p>
                        <div class="ydf-upi-id-box">
                            <span class="ydf-upi-id-text">{{ payeeUpiId }}</span>
                            <button type="button" class="ydf-upi-copy-btn" @click="copyUpiId">
                                <ion-icon :name="upiIdCopied ? 'checkmark-outline' : 'copy-outline'"></ion-icon>
                                {{ upiIdCopied ? 'Copied' : 'Copy' }}
                            </button>
                        </div>
                        <p class="mal-text ydf-bulk-note">ഈ UPI ഐഡി കോപ്പി ചെയ്ത് നിങ്ങളുടെ UPI ആപ്പിൽ (PhonePe / മറ്റുള്ളവ) പേസ്റ്റ് ചെയ്ത് ₹{{ selectedBulkAmount.toFixed(2) }} അയക്കുക. ശേഷം അതിന്റെ Screenshot താഴെ ബട്ടണിൽ upload ചെയ്യുക.</p>
                    </div>
                    <button type="button" class="ydf-bulk-btn" @click="openOnlineVerificationModal">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>വെരിഫിക്കേഷനു വേണ്ടി പെയ്മെൻറ് സ്ലിപ്പ് ഓഫീസിൽ അയക്കുക</span>
                    </button>
                </div>
                <label class="ydf-select-all" v-if="selectedBulkIds.length >= 2">
                    <input type="checkbox" class="ydf-row-check" :checked="allBulkSelected" @change="toggleSelectAllBulk()">
                    <span class="mal-text">എല്ലാ എൻട്രികളും തിരഞ്ഞെടുക്കുക ({{ manualBulkEntries.length }})</span>
                </label>
                <ul class="listview image-listview inset text mt-2 ydf-manual-listview">
                    <li v-for="(m, index) in manualBulkPaged" v-bind:key="m.id">
                        <a href="javascript:void(0)" class="item">
                            <span class="sl-no">{{ (manualBulkPage - 1) * manualBulkPerPage + index + 1 }}</span>
                            <div class="avatar-section">
                                <a href="#">
                                    <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                                </a>
                            </div>
                            <div class="in">
                                <div class="min-width-50">
                                    <b>{{ m.name }}</b>
                                    <footer class="text-primary">{{ m.reciept_no }} | ₹{{ m.amount.toFixed(2) }}</footer>
                                </div>
                            </div>
                            <div class="card-button">
                                <input type="checkbox" class="ydf-row-check" :value="m.id" v-model="selectedBulkIds" @click.stop>
                            </div>
                        </a>
                    </li>
                </ul>
                <div class="section mt-2" v-if="manualBulkEntries.length > manualBulkPerPage">
                    <vue-awesome-paginate :total-items="manualBulkEntries.length" :items-per-page="manualBulkPerPage" :max-pages-shown="3" v-model="manualBulkPage" :on-click="onManualBulkPageClick" :show-ending-buttons="true" :show-breakpoint-buttons="false"
                    />
                </div>
            </template>
        </template>
    </div>

    <!-- Request Online Verification Modal -->
    <div class="modal fade action-sheet" id="onlineVerificationModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">വെരിഫിക്കേഷനു വേണ്ടി പെയ്മെൻറ് സ്ലിപ്പ് ഓഫീസിൽ അയക്കുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <p class="mal-text">{{ selectedBulkIds.length }} എൻട്രികൾ — ആകെ ₹{{ selectedBulkAmount.toFixed(2) }}</p>
                        <div class="office-panel">
                            <div class="office-panel-title">
                                <ion-icon name="receipt-outline"></ion-icon> പേയ്മെന്റ് തെളിവ് <em style="color:#dc3545;">*</em>
                            </div>
                            <label class="upload-box" :class="{ filled: onlineReqSlipName }">
                                <input type="file" accept="image/*,application/pdf" @change="onOnlineReqSlipChange" hidden>
                                <ion-icon :name="onlineReqSlipName ? 'checkmark-circle' : 'cloud-upload-outline'" class="upload-icon"></ion-icon>
                                <span v-if="!onlineReqSlipName" class="upload-text">
                                    Online Transaction ചെയ്ത Screenshot ഇവിടെ upload ചെയ്യുക
                                    <small>image അല്ലെങ്കിൽ PDF (നിർബന്ധം)</small>
                                </span>
                                <span v-else class="upload-text filled-text">
                                    {{ onlineReqSlipName }}
                                    <small>മാറ്റാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക</small>
                                </span>
                            </label>
                            <div class="office-or"><span>കൂടെ</span></div>
                            <div class="input-wrapper">
                                <label class="label" for="online_req_txn"><span>ട്രാൻസാക്ഷൻ ഐഡി <em>(optional)</em></span></label>
                                <input type="text" class="form-control" v-model="onlineReqTxnId" placeholder="Transaction / UTR ID" autocomplete="off">
                            </div>
                        </div>
                        <p class="error-feedback" v-if="onlineReqMsg">{{ onlineReqMsg }}</p>
                        <button type="button" class="btn btn-primary btn-block btn-lg mt-2" :disabled="onlineReqSaving" @click="submitOnlineVerificationRequest">
                            <span v-if="onlineReqSaving" class="spinner-border spinner-border-sm me-1"></span>
                            വെരിഫിക്കേഷനു വേണ്ടി പെയ്മെൻറ് സ്ലിപ്പ് ഓഫീസിൽ അയക്കുക
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ul class="listview image-listview inset text mt-2" v-if="!loading_list && !bulkMode && member_lists.total > 0">
        <li v-for="(member_list, index) in member_lists.data" v-bind:key="member_list.id" :style="rowStyle(member_list)">
            <a href="javascript:void(0)" class="item">
                                    <span class="sl-no">{{ (member_lists.from + index) }}</span>
                                    <div class="avatar-section">
                                        <a href="#">
                                            <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                                            <!-- <span class="button verified" v-if="member_list.member.verified == 'Y'">
                                                <ion-icon name="checkmark-outline"></ion-icon>
                                            </span>
                                            <span class="button not-verified" v-if="member_list.member.verified == 'N' && member_list.member.verification_status">
                                                <ion-icon name="close-outline"></ion-icon>
                                            </span> -->
                                        </a>
            </div>
            <div class="in">
                <div class="min-width-50">
                    <!-- <header>User</header> -->
                    <b> {{ member_list.name }} </b>
                    <footer class="text-primary">{{ member_list.reciept_no }} | ₹{{ member_list.amount.toFixed(2) }}
                    </footer>
                    <footer v-if="is_youth_dawa_fund && member_list.source">
                        <span v-if="member_list.online_request_pending" style="font-size:9px;font-weight:700;white-space:normal;line-height:1.3;display:inline-block;max-width:100%;text-align:center;background:#0dcaf0;color:#055160;border-radius:6px;padding:3px 7px;">⏳ ഓൺലൈൻ അപേക്ഷിച്ചു</span>
                        <span v-else-if="member_list.source === 'online'" class="badge bg-success" style="font-size:10px;">🌐 Online</span>
                        <span v-else-if="member_list.source === 'office' && member_list.office_status === 'pending'" class="badge bg-warning text-dark" style="font-size:10px;">⏳ Office (പരിശോധന ബാക്കി)</span>
                        <span v-else-if="member_list.source === 'office'" class="badge bg-success" style="font-size:10px;">✓ Office (ക്യാഷ് ലഭിച്ചു)</span>
                        <!-- Only Manual/Online/Office are shown — a promoted karad/FFR entry is
                             just a manually-recorded collection from this list's point of view. -->
                        <span v-else class="badge bg-secondary" style="font-size:10px;">Manual</span>
                    </footer>
                    <footer v-if="member_list.source === 'office' && member_list.office_status === 'pending' && member_list.transaction_id" style="font-size:11px;color:#b26a00;margin-top:2px;">
                        Txn: {{ member_list.transaction_id }}
                    </footer>
                    <footer v-if="member_list.source === 'online' && member_list.mobile" style="font-size:12px;color:#555;margin-top:2px;">
                        📞 {{ member_list.mobile }}
                    </footer>
                </div>
                <div class="card-button dropdown" v-if="listYear === currentYear">
                    <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal" :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                            </button>
                </div>
    
                <!-- Default Action Sheet Inset -->
                <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ member_list.name }}</h5>
                            </div>
                            <div class="modal-body">
                                <ul class="action-button-list">
                                    <!-- Call button for online payments with mobile -->
                                    <li v-if="member_list.source === 'online' && member_list.mobile">
                                        <a :href="'tel:' + member_list.mobile" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="call-outline"></ion-icon> Call
                                            </span>
                                        </a>
                                    </li>
                                    <!-- WhatsApp button for online payments with mobile -->
                                    <li v-if="member_list.source === 'online' && member_list.mobile">
                                        <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                            @click="openWhatsApp(member_list)">
                                            <span>
                                                <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="!allBooksTakenBack">
                                        <a href="javascript:void(0)" @click="adminView(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="pencil-outline"></ion-icon> Edit
                                            </span>
                                        </a>
                                    </li>
                                    <!-- Plain anchor straight to the PDF, exactly like the Nerpatham receipt
                                         download (NerpathamList.vue) — no @click handler doing the
                                         navigation itself; window.location.href from a handler was not
                                         reliable on iOS Safari. NOTE: deliberately NOT data-bs-dismiss="modal"
                                         here — Bootstrap's own modal.js calls event.preventDefault() on any
                                         <a>/<area> carrying that attribute, which silently killed this
                                         anchor's href navigation entirely (no request ever fired). The
                                         modal is closed manually instead, via a plain @click that doesn't
                                         touch the click event, so the native navigation still proceeds. -->
                                    <li>
                                        <a :href="receiptDownloadUrl(member_list)" class="btn btn-list"
                                            @click="closeActionSheet(member_list.id)">
                                            <span>
                                                <ion-icon name="download-outline"></ion-icon> Receipt Download
                                            </span>
                                        </a>
                                    </li>
                                    <!-- Entries with a placeholder "T..." number (auto-assigned when there
                                         was no physical leaf at the time, e.g. an online donation) can be
                                         reassigned to a real leaf number picked from this unit's books. -->
                                    <li v-if="String(member_list.reciept_no || '').startsWith('T')">
                                        <a href="javascript:void(0)" @click="openAssignReceiptModal(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="bookmark-outline"></ion-icon> രസീത് നമ്പർ നൽകുക
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="member_list.source !== 'online' && !allBooksTakenBack">
                                        <a href="javascript:void(0)" @click="adminDeleteConfirmation(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="trash-outline"></ion-icon> Remove
                                            </span>
                                        </a>
                                    </li>
                                    <li class="action-divider"></li>
                                    <li>
                                        <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- * Default Action Sheet Inset -->
            </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="!loading_list && !bulkMode">
        <vue-awesome-paginate v-if="member_lists.total > 0" :total-items="member_lists.total" :items-per-page="member_lists.per_page" :max-pages-shown="3" v-model="member_lists.current_page" :on-click="getMembersList" :show-ending-buttons="true" :show-breakpoint-buttons="false"
        />
    </div>

    <!-- Assign Receipt Number Modal — replace a placeholder "T..." number with a real leaf -->
    <div class="modal fade action-sheet" id="assignReceiptModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">രസീത് നമ്പർ നൽകുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <p class="mb-2" v-if="assignReceipt_admin">
                            <b>{{ assignReceipt_admin.name }}</b>
                            <span class="text-muted"> — നിലവിൽ: {{ assignReceipt_admin.reciept_no }}</span>
                        </p>
                        <div class="form-group basic">
                            <label class="label mal-text">ലഭ്യമായ രസീത് നമ്പർ</label>
                            <select class="form-control custom-select" v-model="assignReceipt_selected" :disabled="assignReceipt_loading">
                                <option value="">---Select---</option>
                                <option v-for="n in assignReceipt_numbers" :key="n" :value="n">{{ n }}</option>
                            </select>
                        </div>
                        <div v-if="assignReceipt_loading" class="text-center py-2">
                            <div class="spinner-border spinner-border-sm text-secondary"></div>
                        </div>
                        <p class="error-feedback" v-if="assignReceipt_msg">{{ assignReceipt_msg }}</p>
                        <button type="button" class="btn btn-primary btn-block btn-lg mt-2"
                            :disabled="!assignReceipt_selected || assignReceipt_saving" @click="saveAssignReceipt">
                            <span v-if="assignReceipt_saving" class="spinner-border spinner-border-sm me-1"></span>
                            സേവ് ചെയ്യുക
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Receipt Book Timeline Modal -->
    <div class="modal fade action-sheet" id="bookTimelineModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">
                        റസീപ്റ്റ് ബുക്ക് ടൈംലൈൻ
                        <span v-if="timeline_book" style="color:#1a418c;"> — Book #{{ timeline_book.book_number }}</span>
                    </h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content" style="max-height:480px;overflow-y:auto;">
                        <!-- Book info bar -->
                        <div v-if="timeline_book && timeline_book.receipt_from" style="background:#f4f7ff;border-radius:8px;padding:10px 14px;margin-bottom:14px;">
                            <div style="display:flex;gap:16px;flex-wrap:wrap;margin-bottom:6px;">
                                <div>
                                    <div style="font-size:10px;color:#64748b;font-weight:500;" class="mal-text">ലഭ്യമായ ലീഫ് നമ്പർ</div>
                                    <div style="font-size:13px;font-weight:700;color:#1a418c;">
                                        {{ timeline_book.receipt_from }} – {{ timeline_book.receipt_to }}
                                    </div>
                                </div>
                                <div>
                                    <div style="font-size:10px;color:#64748b;font-weight:500;" class="mal-text">ആകെ ലീഫ്</div>
                                    <div style="font-size:13px;font-weight:700;color:#374151;">
                                        {{ timeline_book.receipt_to - timeline_book.receipt_from + 1 }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="timeline_loading" class="text-center py-4">
                            <div class="spinner-border spinner-border-sm text-secondary"></div>
                        </div>
                        <div v-else-if="!timeline_entries.length && !(timeline_book && timeline_book.holder_name)" class="text-center py-4">
                            <ion-icon name="time-outline" style="font-size:32px;color:#cbd5e1;"></ion-icon>
                            <p class="mal-text mt-2" style="font-size:13px;color:#94a3b8;">ഇതുവരെ ഒരു ചുമതലക്കാരനും accept ചെയ്തിട്ടില്ല</p>
                        </div>
                        <div v-else-if="!timeline_entries.length && timeline_book && timeline_book.holder_name" style="display:flex;gap:12px;position:relative;">
                            <div style="width:40px;height:40px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;background:#1a418c;color:#fff;font-size:18px;box-shadow:0 0 0 2px #1a418c;">
                                <ion-icon name="person"></ion-icon>
                            </div>
                            <div style="flex:1;background:#fff;border:1px solid #e2e8f0;border-radius:10px;padding:10px 12px;">
                                <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;">
                                    <span style="font-size:13px;font-weight:700;color:#1e293b;">{{ timeline_book.holder_name }}</span>
                                    <span style="font-size:10px;font-weight:600;background:#dcfce7;color:#16a34a;padding:2px 7px;border-radius:20px;">✓ നിലവിൽ</span>
                                </div>
                                <div v-if="timeline_book.received_at" style="font-size:11px;color:#64748b;">
                                    <span class="mal-text" style="color:#94a3b8;">Accept: </span>
                                    <strong style="color:#374151;">{{ timeline_book.received_at }}</strong>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="timeline_entries.length" style="position:relative;">
                            <!-- Vertical line -->
                            <div style="position:absolute;left:20px;top:0;bottom:0;width:2px;background:#e2e8f0;"></div>

                            <div v-for="entry in timeline_entries" :key="entry.id"
                                style="display:flex;gap:12px;margin-bottom:20px;position:relative;">
                                <!-- Circle -->
                                <div :style="{
                                    width: '40px', height: '40px', borderRadius: '50%', flexShrink: '0',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    background: entry.is_current ? '#1a418c' : '#e2e8f0',
                                    color: entry.is_current ? '#fff' : '#64748b',
                                    fontSize: '18px', zIndex: '1', border: '3px solid #fff',
                                    boxShadow: '0 0 0 2px ' + (entry.is_current ? '#1a418c' : '#cbd5e1')
                                }">
                                    <ion-icon :name="entry.is_current ? 'person' : 'person-outline'"></ion-icon>
                                </div>

                                <!-- Content card -->
                                <div style="flex:1;min-width:0;background:#fff;border:1px solid #e2e8f0;border-radius:10px;padding:10px 12px;">
                                    <!-- Header row -->
                                    <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:4px;">
                                        <span style="font-size:13px;font-weight:700;color:#1e293b;">{{ entry.holder_name || '—' }}</span>
                                        <span v-if="entry.is_current"
                                            style="font-size:10px;font-weight:600;background:#dcfce7;color:#16a34a;padding:2px 7px;border-radius:20px;">
                                            ✓ നിലവിൽ
                                        </span>
                                    </div>
                                    <!-- Dates -->
                                    <div style="font-size:11px;color:#64748b;margin-bottom:6px;">
                                        <span class="mal-text" style="color:#94a3b8;">Accept: </span>
                                        <strong style="color:#374151;">{{ entry.started_at }}</strong>
                                        <span v-if="entry.ended_at">
                                            <br><span class="mal-text" style="color:#94a3b8;">മാറ്റിയത്: </span>
                                            <strong style="color:#374151;">{{ entry.ended_at }}</strong>
                                        </span>
                                        <span v-else>
                                            &nbsp;<span style="font-size:10px;color:#16a34a;" class="mal-text">— നിലവിൽ</span>
                                        </span>
                                    </div>
                                    <!-- Stats row -->
                                    <div style="display:flex;gap:10px;flex-wrap:wrap;">
                                        <div style="background:#f0fdf4;border-radius:6px;padding:4px 10px;text-align:center;">
                                            <div style="font-size:16px;font-weight:800;color:#16a34a;">{{ entry.collections_count }}</div>
                                            <div style="font-size:10px;color:#64748b;" class="mal-text">ശേഖരിച്ചത്</div>
                                        </div>
                                        <div style="background:#f0f9ff;border-radius:6px;padding:4px 10px;text-align:center;">
                                            <div style="font-size:16px;font-weight:800;color:#0369a1;">₹{{ Number(entry.collections_amount).toFixed(0) }}</div>
                                            <div style="font-size:10px;color:#64748b;" class="mal-text">തുക</div>
                                        </div>
                                        <div v-if="timeline_book && timeline_book.receipt_from" style="background:#fef9c3;border-radius:6px;padding:4px 10px;text-align:center;">
                                            <div style="font-size:16px;font-weight:800;color:#92400e;">
                                                {{ timeline_book.receipt_to - timeline_book.receipt_from + 1 - entry.collections_count > 0
                                                    ? timeline_book.receipt_to - timeline_book.receipt_from + 1 - entry.collections_count
                                                    : 0 }}
                                            </div>
                                            <div style="font-size:10px;color:#64748b;" class="mal-text">ബാക്കി</div>
                                        </div>
                                    </div>
                                    <!-- Receipt numbers used -->
                                    <div v-if="entry.receipt_numbers && entry.receipt_numbers.length" style="margin-top:8px;">
                                        <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;" class="mal-text">ഉപയോഗിച്ച ലീഫ് നമ്പറുകൾ:</div>
                                        <div style="display:flex;flex-wrap:wrap;gap:4px;">
                                            <span v-for="n in entry.receipt_numbers" :key="n"
                                                style="font-size:11px;background:#e0e7ff;color:#3730a3;padding:2px 7px;border-radius:4px;font-weight:600;">
                                                {{ n }}
                                            </span>
                                        </div>
                                    </div>
                                    <!-- Changed by -->
                                    <div v-if="entry.changed_by_name" style="margin-top:6px;font-size:11px;color:#94a3b8;">
                                        <ion-icon name="swap-horizontal-outline" style="vertical-align:middle;margin-right:2px;"></ion-icon>
                                        <span class="mal-text">ചുമതല നൽകിയത്: </span> {{ entry.changed_by_name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from 'jquery';
import vSelect from 'vue-select'
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import HelpDeskCard from "../../components/HelpDeskCard.vue";
import TutorialButton from "../../components/TutorialButton.vue";
export default {
    name: 'Admin List',
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
        DialogModel,
        HelpDeskCard,
        TutorialButton
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            officeMode: false,
            transaction_id: '',
            mobile: '',
            slipFile: null,
            slipFileName: '',
            existingSlipUrl: '',
            member_lists: [],
            member_list: [],
            member: [],
            unit: [],
            editable_id: '',
            editable: false,
            // Assign Receipt Number modal — replaces a placeholder "T..." number with a real leaf.
            assignReceipt_admin: null,
            assignReceipt_numbers: [],
            assignReceipt_selected: '',
            assignReceipt_loading: false,
            assignReceipt_saving: false,
            assignReceipt_msg: '',
            permissions: [],
            add_admin: false,
            total: 0.00,
            target: 0.00,
            isMember: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            member_edit: false,
            receipt_no: '',
            amount: '',
            isEdit: false,
            sub_level_name: '',
            district_eligible: false,
            zone_eligible: false,
            percentage:[],
            listYear: new Date().getFullYear(),
            receiptBooks: [],
            availableReceiptNumbers: [],
            is_youth_dawa_fund: false,
            // Full settlement sheet for this page's own level (unit/zone/district) — also drives
            // the badge on the Book Take-Back entry button below, and the Request Share/Mark
            // Share Taken actions further down on this same dashboard.
            settlementStatus: null,
            latestShareRequestStatus: null,
            shareTakenSaving: false,
            // Request Share Fund modal state — mirrors BookTakeBack.vue's fields.
            requestShareAmount: '',
            requestShareReason: '',
            requestShareSaving: false,
            requestShareMsg: '',
            requestSharePaymentMethod: 'upi',
            requestShareUpiId: '',
            requestShareGpayMobile: '',
            requestShareGpayName: '',
            requestShareAccountHolderName: '',
            requestShareAccountNumber: '',
            requestShareIfscCode: '',
            // Bulk "request online verification" — full unpaginated manual-entries list + proof upload
            bulkMode: false,
            manualBulkEntries: [],
            manualBulkLoading: false,
            manualBulkPage: 1,
            manualBulkPerPage: 20,
            payeeUpiId: 'wisdomyouthkerala@sbi',
            upiIdCopied: false,
            selectedBulkIds: [],
            onlineReqSlipFile: null,
            onlineReqSlipName: '',
            onlineReqTxnId: '',
            onlineReqSaving: false,
            onlineReqMsg: '',
            receiveBook_id: null,
            receiveBook_number: '',
            receiveBook_from: '',
            receiveBook_to: '',
            receiveBook_holder: '',
            receiveBook_saving: false,
            receiveBook_search: '',
            receiveBook_selected: null,
            receiveBook_results: [],
            receiveBook_searching: false,
            receiveBook_timer: null,
            changeHolder_id: null,
            changeHolder_number: '',
            changeHolder_name: '',
            changeHolder_saving: false,
            changeHolder_search: '',
            changeHolder_selected: null,
            changeHolder_results: [],
            changeHolder_searching: false,
            changeHolder_timer: null,
            timeline_book: null,
            timeline_entries: [],
            timeline_loading: false,
            toMeetCount: 0,
            metCount: 0,
            toMeetList: [],
            metList: [],
            visitModalType: 'to_meet',
            visitModalList: [],
            fundCollection: {
                add_disabled: false,
                add_disabled_at: null,
                state_payment_started_at: null,
                state_payment_started_amount: null,
            }

        };
    },

    computed: {
        schema() {
            if (this.officeMode) {
                return yup.object().shape({
                    amount: yup.string().required("ഫിൽ ചെയ്യുക!"),
                });
            }
            return yup.object().shape({
                receipt_no: yup.string().required("ഫിൽ ചെയ്യുക!"),
                amount: yup.string().required("ഫിൽ ചെയ്യുക!"),
            });
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        currentYear() {
            return new Date().getFullYear();
        },
        bookId() {
            return this.$route.query.book_id ? parseInt(this.$route.query.book_id) : null;
        },
        isUnitLevelPage() {
            return parseInt(this.user_level) === 4;
        },
        isTargetAchieved() {
            return (this.target ?? 0) > 0 && (this.total ?? 0) >= (this.target ?? 0);
        },
        hasReceivedBook() {
            return this.receiptBooks.some((b) => b.received);
        },
        allBooksTakenBack() {
            return this.is_youth_dawa_fund && this.receiptBooks.length > 0 && this.receiptBooks.every((b) => !!b.taken_back_at);
        },
        // Mirrors BookTakeBack.vue's moneyEffectivelyReceived() — once Zone approves a request
        // AND the unit confirms the money arrived, the shortfall is resolved in practice.
        moneyEffectivelyReceived() {
            const r = this.latestShareRequestStatus;
            return !!(r && r.status === 'approved' && r.received_status === 'received');
        },
        // This level's own figures are "final" and ready for Request Share/Mark Share Taken —
        // for a Unit that means every receipt book is verified and taken back (no children to
        // wait on); for Zone/District it means every level below has settled its own share
        // (settlementStatus.sub_levels_settled, same gate used on HighLevelReport.vue's cards).
        readyForShareAction() {
            if (this.user_level === 4) return this.allBooksTakenBack;
            return !!(this.settlementStatus && this.settlementStatus.sub_levels_settled);
        },
        // Zone requests from District, District requests from State, Unit requests from Zone —
        // hop-by-hop, not skip-to-State (mirrors HighLevelReport.vue's requestShareTargetLabel).
        requestShareTargetLabel() {
            if (this.user_level === 4) return 'മണ്ഡലം';
            return this.user_level === 3 ? 'ജില്ല' : 'സ്റ്റേറ്റ്';
        },
        // Correctly-cased "from X"/"to X" phrases per level — Unit's is its own established
        // grammatical form (മണ്ഡലത്തിൽ/മണ്ഡലത്തിലേക്ക്), Zone/District match the exact suffix
        // pattern already shipped on HighLevelReport.vue for consistency across both pages.
        requestShareFromLabel() {
            return this.user_level === 4 ? 'മണ്ഡലത്തിൽ' : this.requestShareTargetLabel + 'ൽ';
        },
        requestShareToLabel() {
            return this.user_level === 4 ? 'മണ്ഡലത്തിലേക്ക്' : this.requestShareTargetLabel + 'ലേക്ക്';
        },
        // Whether the dashboard's own "Request Share Fund" button should show — same gating as
        // the equivalent branch on BookTakeBack.vue, just without duplicating the pending/
        // approved-unconfirmed/rejected status cards here (those stay covered by the badges on
        // the Book Take-Back entry above, one tap away for the fuller detail).
        canRequestShare() {
            if (!this.readyForShareAction || !this.settlementStatus) return false;
            if (!(this.settlementStatus.shortfall > 0) || this.moneyEffectivelyReceived) return false;
            const r = this.latestShareRequestStatus;
            if (r && r.status === 'pending') return false;
            if (r && r.status === 'approved' && !r.received_status) return false;
            return true;
        },
        // Whether the "Mark Share Taken" button/status-card should show — the other half of the
        // same settlement flow, once there's no shortfall left to request (or it's been resolved).
        showMarkShareTaken() {
            return this.readyForShareAction && !!this.settlementStatus
                && !(this.settlementStatus.shortfall > 0 && !this.moneyEffectivelyReceived);
        },
        showAddButton() {
            if (!(this.permissions.update && this.listYear === this.currentYear)) return false;
            // Youth Dawa Fund never restricts adding once the target is reached — ignore
            // add_disabled entirely for it (including any unit disabled before this changed).
            if (this.fundCollection?.add_disabled && !this.is_youth_dawa_fund) return false;
            // Youth Dawa Fund: only allow adding once at least one receipt book is received
            if (this.is_youth_dawa_fund && !this.hasReceivedBook) return false;
            // Once every book is verified and handed back to the zone, the unit is closed out —
            // no more entries.
            if (this.allBooksTakenBack) return false;
            return true;
        },
        showDisableAddButton() {
            if (!(this.permissions.update && this.listYear === this.currentYear)) return false;
            if (!this.isUnitLevelPage) return false;
            if (this.is_youth_dawa_fund) return false;
            if (!this.isTargetAchieved) return false;
            return !(this.fundCollection?.add_disabled);
        },
        showStatePaymentButton() {
            if (!(this.permissions.update && this.listYear === this.currentYear)) return false;
            if (!this.isUnitLevelPage) return false;
            if (this.is_youth_dawa_fund) return false;
            if (!(this.fundCollection?.add_disabled)) return false;
            // Only show payment button when there is some state share amount
            return this.stateShareAmount > 0;
        },
        stateShareAmount() {
            const val = this.getPercentage(this.target ? this.target : 0, this.total, 1);
            const parsed = parseFloat(val);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        minusToZero() {
            let value = this.target - this.total;
            if (value <= 0) {
                return '0';
            } else {
                return value.toFixed(2);
            }
        },
        allBulkSelected() {
            return this.manualBulkEntries.length > 0 && this.selectedBulkIds.length === this.manualBulkEntries.length;
        },
        manualBulkPaged() {
            const start = (this.manualBulkPage - 1) * this.manualBulkPerPage;
            return this.manualBulkEntries.slice(start, start + this.manualBulkPerPage);
        },
        selectedBulkAmount() {
            return this.manualBulkEntries
                .filter(m => this.selectedBulkIds.includes(m.id))
                .reduce((sum, m) => sum + parseFloat(m.amount || 0), 0);
        },
        // Bare-minimum payload (pa + am + cu only, no pn/tn) — re-tried per explicit request even
        // though this exact combination previously failed on a real device ("Payment Failed").
        // iOS: Google Pay's own gpay://upi/pay scheme (their merchant-integration deep link).
        // Android: intent://...package=... targeting the same Google Pay package directly.
        gpayLink() {
            const query = 'pa=' + encodeURIComponent(this.payeeUpiId)
                + '&am=' + encodeURIComponent(this.selectedBulkAmount.toFixed(2))
                + '&cu=INR';
            if (/Android/i.test(navigator.userAgent || '')) {
                return 'intent://upi/pay?' + query + '#Intent;scheme=upi;package=com.google.android.apps.nbu.paisa.user;end';
            }
            return 'gpay://upi/pay?' + query;
        },
    },
    // This route (/org/:sub_level/:id/fund-collection/:type) is shared by unit, zone, AND
    // district dashboards — navigating between two of them (e.g. a zone's own dashboard link
    // straight to one of its units) is a param change on the SAME component, which Vue Router
    // reuses without re-running mounted(). Without this watcher, user_level (and everything
    // derived from it — requestShareTargetLabel, settlementStatus, the member list itself) stayed
    // stale at whatever level the component was first mounted for, e.g. a unit page still showing
    // "സ്റ്റേറ്റ്ൽ നിന്ന്..." (District's own target) after being reached from a district dashboard.
    watch: {
        '$route.params.sub_level'() { this.reinitForRoute(); },
        '$route.params.id'() { this.reinitForRoute(); },
        '$route.params.type'() { this.reinitForRoute(); },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.reinitForRoute();
            this.$root.updateParent('Loading...');
        }
        // this.getComboboxValues('COUNTRY_CODE');
        window.onpopstate = function() {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        reinitForRoute() {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.getMembersList(1);
        },
        // Distribution: 100%+ target → Unit 15%, Zone 10%, District 10%, State 65%; 75–99% → State 85%, 5% each; <75% → 100% state
        getPercentage(target, total, type) {
            // Youth Dawa Fund uses its own flat split, unconditional on the target-reached
            // tiers other funds use: Branch/Unit 20%, Zone 10%, District 5%, State 65%.
            if (this.is_youth_dawa_fund) {
                const ydfPct = { 1: 65, 2: 5, 3: 10, 4: 20 }[type] ?? 0;
                return ((total / 100) * ydfPct).toFixed(2);
            }
            const threshold75 = target ? (target * 75) / 100 : 0;
            const reached100 = target && total >= target;
            const reached75 = total >= threshold75;
            let pct;
            if (reached100) {
                if (type == 1) pct = 65;
                else if (type == 2) pct = 10;
                else if (type == 3) pct = 10;
                else if (type == 4) pct = 15;
            } else if (reached75) {
                if (type == 1) pct = this.percentage.state_75 ?? 85;
                else if (type == 2) pct = this.percentage.district_75 ?? 5;
                else if (type == 3) pct = this.percentage.zone_75 ?? 5;
                else if (type == 4) pct = this.percentage.unit_75 ?? 5;
            } else {
                if (type == 1) pct = 100;
                else pct = 0;
            }
            return ((total / 100) * (pct ?? 0)).toFixed(2);
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            break;
                        case 'UNVERIFIED_REASON':
                            this.verification_status_list = response.data.data.list.options;
                            break;

                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminView(admin) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.isEdit = true;
            this.mobile = admin.mobile || '';
            this.slipFile = null;
            this.slipFileName = '';
            if (admin.member_id) {
                this.member_id = admin.member_id;
                this.disable_member_form = true;
            } else {
                this.disable_member_form = false;
            }
            this.name = admin.name;
            this.amount = admin.amount;
            this.member_edit = false;
            this.member_list.push(this.member);
            this.editable_id = admin.id;
            this.add_admin = false;
            this.edit_admin = true;

            // Office-pending entries have no receipt_no yet (it's only generated once office
            // verifies) — editing them needs the transaction id / slip fields instead of the
            // generic receipt-number field, which would otherwise validate a null receipt_no.
            const isOfficePending = admin.source === 'office' && admin.office_status === 'pending';
            this.officeMode = isOfficePending;
            if (isOfficePending) {
                this.transaction_id = admin.transaction_id || '';
                this.existingSlipUrl = admin.slip_url || '';
                this.receipt_no = '';
            } else {
                this.transaction_id = '';
                this.existingSlipUrl = '';
                this.receipt_no = admin.reciept_no;
                this.loadAvailableReceiptNumbers(admin.reciept_no, admin.id);
            }
        },
        // Entries with a placeholder "T..." number (auto-assigned when there was no physical
        // leaf yet, e.g. an online donation matched to this unit after the fact) can be
        // reassigned to a real leaf number from this unit's received books.
        openAssignReceiptModal(admin) {
            this.assignReceipt_admin = admin;
            this.assignReceipt_selected = '';
            this.assignReceipt_msg = '';
            this.assignReceipt_numbers = [];
            this.assignReceipt_loading = true;
            $('#assignReceiptModal').modal('show');
            UserService.authPostRequest('receipt-book/available-receipt-numbers', {
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
            }).then((response) => {
                this.assignReceipt_loading = false;
                if (response.data.status === 'success') {
                    this.assignReceipt_numbers = response.data.data.numbers || [];
                }
            }).catch(() => {
                this.assignReceipt_loading = false;
            });
        },
        saveAssignReceipt() {
            if (!this.assignReceipt_selected || this.assignReceipt_saving || !this.assignReceipt_admin) return;
            this.assignReceipt_saving = true;
            this.assignReceipt_msg = '';
            const admin = this.assignReceipt_admin;
            const user = {
                editable_id: admin.id,
                unit_id: parseInt(this.$route.params.id),
                fund_type: this.$route.params.type,
                name: admin.name,
                mobile: admin.mobile,
                amount: admin.amount,
                receipt_no: this.assignReceipt_selected,
                member_id: admin.member_id || null,
            };
            UserService.addAdmin('store-fund-collections', user).then((response) => {
                this.assignReceipt_saving = false;
                if (response.data.status === 'success') {
                    $('#assignReceiptModal').modal('hide');
                    this.alert_type = 'Success';
                    this.alert_message = 'രസീത് നമ്പർ അപ്ഡേറ്റ് ചെയ്തു.';
                    this.$refs.alert_model.openModel();
                    this.getMembersList(1, 6);
                } else {
                    this.assignReceipt_msg = response.data.message || 'പിശക് സംഭവിച്ചു.';
                }
            }).catch((error) => {
                this.assignReceipt_saving = false;
                this.assignReceipt_msg = (error.response && error.response.data && error.response.data.message) || 'പിശക് സംഭവിച്ചു.';
            });
        },
        // Built as a plain href (see the template) rather than navigated to from a click
        // handler — mirrors the Nerpatham receipt download, which is the version proven to work
        // on iOS. Direct route straight to FundCollectionController::printReceiptPdf() — NOT the
        // old donation/download-receipt?fc=1 piggyback, which manually invoked that controller
        // method outside Laravel's normal routing and was the actual cause of every mobile
        // failure investigated on 2026-07-29 (see routes/web.php for the full writeup).
        receiptDownloadUrl(admin) {
            return 'https://guideportal.wisdomislam.org/donation/download-youth-dawa-fund-receipt/' + admin.id;
        },
        // Close the per-row action sheet without data-bs-dismiss="modal" on the Receipt
        // Download anchor — see the comment on that <a> for why.
        closeActionSheet(memberId) {
            $('#actionSheetInset' + memberId).modal('hide');
        },
        adminAdd() {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.disable_member_form = false;
            this.name = '';
            this.receipt_no = '';
            this.member_edit = true;
            this.amount = '';
            this.editable_id = null;
            this.add_admin = true;
            this.edit_admin = false;
            this.officeMode = false;
            this.transaction_id = '';
            this.mobile = '';
            this.slipFile = null;
            this.slipFileName = '';
            this.existingSlipUrl = '';
            this.loadAvailableReceiptNumbers();
        },
        onSlipChange(e) {
            const file = e.target.files && e.target.files[0];
            this.slipFile = file || null;
            this.slipFileName = file ? file.name : '';
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            this.loading = true;
            // Editing an existing office-pending payment (Amount/Transaction ID/Slip only) goes
            // through the dedicated update endpoint — store-fund-collections' office branch is
            // only for a brand new submission, not editing one that's already linked.
            if (this.officeMode && this.edit_admin) {
                if (!this.amount || parseFloat(this.amount) <= 0) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'തുക നൽകുക.';
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                    return false;
                }
                const hasExisting = this.existingSlipUrl || this.transaction_id;
                if (!this.slipFile && !(this.transaction_id && this.transaction_id.trim()) && !hasExisting) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'പേയ്മെന്റ് സ്ലിപ്പ് അപ്‌ലോഡ് ചെയ്യുക അല്ലെങ്കിൽ ട്രാൻസാക്ഷൻ ഐഡി നൽകുക.';
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                    return false;
                }
                const fd = new FormData();
                fd.append('id', this.editable_id);
                fd.append('amount', this.amount);
                if (this.transaction_id) fd.append('transaction_id', this.transaction_id);
                if (this.slipFile) fd.append('slip', this.slipFile);
                UserService.authPostRequest('update-office-payment', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.status === 'success') {
                            $('#addAdminModel').modal('hide');
                            this.alert_type = 'Success';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            this.getMembersList(1, 6);
                        } else {
                            this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                        this.$refs.alert_model.openModel();
                    }
                );
                return;
            }
            user.editable_id = this.editable_id;
            user.unit_id = parseInt(this.$route.params.id);
            user.fund_type = this.$route.params.type;
            user.is_member = this.isMember;
            user.is_office = this.officeMode;
            user.transaction_id = this.officeMode ? this.transaction_id : null;
            // Mobile: from the selected member, else the typed number
            user.mobile = (this.isMember == 'Y' && this.member && this.member.mobile) ? this.member.mobile : this.mobile;
            if (this.isMember == 'Y') {
                if (this.member) {
                    if (this.member.length == 0) {
                        this.alert_type = 'Warning';
                        this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക.';
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        return false;
                    }
                } else {
                    this.alert_type = 'Warning';
                    this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക.';
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                    return false;
                }

            }
            if (this.isMember == 'N' && !user.name) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി പേര് ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return false;
            }
            if (this.isMember == 'Y') {
                user.member_id = this.member.id;
            } else {
                user.member_id = null;
            }
            // Office mode: payment slip upload is mandatory
            if (this.officeMode && !this.slipFile) {
                this.alert_type = 'Warning';
                this.alert_message = 'പേയ്മെന്റ് സ്ലിപ്പ് അപ്‌ലോഡ് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return false;
            }
            let savePromise;
            if (this.officeMode) {
                const fd = new FormData();
                Object.keys(user).forEach((k) => {
                    if (user[k] !== null && user[k] !== undefined) fd.append(k, user[k]);
                });
                if (this.slipFile) fd.append('slip', this.slipFile);
                savePromise = UserService.authPostRequest('store-fund-collections', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            } else {
                savePromise = UserService.addAdmin('store-fund-collections', user);
            }
            savePromise.then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        // Bulk "send branch's held amount to State" — full unpaginated manual-entries list,
        // swapped into the main list area in place (paged client-side so selection persists
        // across pages instead of resetting per paginated fetch).
        toggleSelectAllBulk() {
            this.selectedBulkIds = this.allBulkSelected ? [] : this.manualBulkEntries.map(m => m.id);
        },
        onManualBulkPageClick(page) {
            this.manualBulkPage = page;
        },
        openManualBulk() {
            this.bulkMode = true;
            this.manualBulkLoading = true;
            this.manualBulkEntries = [];
            this.manualBulkPage = 1;
            this.selectedBulkIds = [];
            let data = {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.listYear,
            };
            UserService.authPostRequest('get-manual-fund-collections', data).then(
                (response) => {
                    this.manualBulkLoading = false;
                    if (response.data.status == 'success') {
                        this.manualBulkEntries = response.data.data.list;
                    }
                },
                () => {
                    this.manualBulkLoading = false;
                }
            );
        },
        closeManualBulk() {
            this.bulkMode = false;
            this.manualBulkEntries = [];
            this.manualBulkPage = 1;
            this.selectedBulkIds = [];
        },
        copyUpiId() {
            const done = () => {
                this.upiIdCopied = true;
                setTimeout(() => { this.upiIdCopied = false; }, 2000);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(this.payeeUpiId).then(done).catch(() => {});
            } else {
                const el = document.createElement('textarea');
                el.value = this.payeeUpiId;
                el.style.position = 'fixed';
                el.style.opacity = '0';
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                done();
            }
        },
        // Bulk "request online verification"
        onOnlineReqSlipChange(e) {
            const file = e.target.files[0];
            this.onlineReqSlipFile = file || null;
            this.onlineReqSlipName = file ? file.name : '';
        },
        openOnlineVerificationModal() {
            if (!this.selectedBulkIds.length) return;
            this.onlineReqSlipFile = null;
            this.onlineReqSlipName = '';
            this.onlineReqTxnId = '';
            this.onlineReqMsg = '';
            $('#onlineVerificationModal').modal('show');
        },
        submitOnlineVerificationRequest() {
            if (!this.onlineReqSlipFile) {
                this.onlineReqMsg = 'Online Transaction ചെയ്ത Screenshot upload ചെയ്യുക.';
                return;
            }
            this.onlineReqSaving = true;
            this.onlineReqMsg = '';
            const fd = new FormData();
            this.selectedBulkIds.forEach(id => fd.append('ids[]', id));
            if (this.onlineReqTxnId && this.onlineReqTxnId.trim()) fd.append('transaction_id', this.onlineReqTxnId.trim());
            if (this.onlineReqSlipFile) fd.append('slip', this.onlineReqSlipFile);
            UserService.authPostRequest('request-online-verification', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(
                (response) => {
                    this.onlineReqSaving = false;
                    if (response.data.status == 'success') {
                        $('#onlineVerificationModal').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.selectedBulkIds = [];
                        if (this.bulkMode) {
                            this.openManualBulk();
                        } else {
                            this.manualBulkEntries = [];
                        }
                        this.getMembersList(this.member_lists.current_page || 1);
                    } else {
                        this.onlineReqMsg = response.data.message;
                    }
                },
                (error) => {
                    this.onlineReqSaving = false;
                    this.onlineReqMsg = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                }
            );
        },
        rowStyle(item) {
            if (item.source === 'office' && item.office_status === 'pending') {
                return { 'background-color': '#fff3e0' }; // orange tint — unverified office
            }
            if (item.source === 'office' && item.office_status === 'verified') {
                return { 'background-color': '#e8f5e9' }; // green tint — verified (cash received)
            }
            return {};
        },
        adminDelete(data) {
            UserService.authPostRequest('delate-fund-collections', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        loadVisitCounts() {
            if (!this.is_youth_dawa_fund) return;
            UserService.authPostRequest('get-visit-counts', {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.listYear,
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.toMeetCount = response.data.data.to_meet_count;
                    this.metCount = response.data.data.met_count;
                    this.toMeetList = response.data.data.to_meet_list;
                    this.metList = response.data.data.met_list;
                }
            });
        },
        // Badge on the Book Take-Back entry button, plus this page's own Request Share/Mark
        // Share Taken block further down — user_level is this page's own org level (2/3/4).
        loadSettlementStatus() {
            UserService.authPostRequest('get-fund-collection-settlement-sheet', {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.settlementStatus = response.data.data;
                }
            }).catch(() => {});
        },
        // Just the latest Request Share Fund status, for the same badge — full list + Received/
        // Not-Received actions live on the Book Take-Back page now.
        loadMyShareRequestStatus() {
            UserService.authPostRequest('get-my-submitted-share-requests', {
                requesting_level: this.user_level,
                requesting_level_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
            }).then((response) => {
                if (response.data.status === 'success') {
                    const list = response.data.data.requests || [];
                    this.latestShareRequestStatus = list.length ? list[0] : null;
                }
            }).catch(() => {});
        },
        // Mark Share Taken — same flow as HighLevelReport.vue's confirmMarkShareTaken()/
        // markShareTakenAction()/cancelShareTakenAction(), reusing this page's own generic
        // dialog-model confirmation pattern (see adminDelete()/disableAdd() elsewhere here).
        confirmMarkShareTaken() {
            const amt = this.settlementStatus ? this.settlementStatus.net_payable.toFixed(2) : '0.00';
            this.dialog_message = '₹' + amt + ' വിഹിതം എടുത്തു എന്നും ബാക്കി തുക ' + this.requestShareToLabel + ' അയച്ചു എന്നും സ്ഥിരീകരിക്കണോ?';
            this.dialog_action = 'markShareTakenAction';
            this.dialog_action_params = {};
            this.$refs.dialog_model.openModel();
        },
        markShareTakenAction() {
            this.shareTakenSaving = true;
            UserService.authPostRequest('mark-share-taken', {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
            }).then(
                (response) => {
                    this.shareTakenSaving = false;
                    if (response.data.status === 'success') {
                        this.loadSettlementStatus();
                    } else {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.shareTakenSaving = false;
                    this.alert_type = 'Warning';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        cancelShareTakenAction() {
            this.shareTakenSaving = true;
            UserService.authPostRequest('cancel-share-taken', {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
            }).then(
                (response) => {
                    this.shareTakenSaving = false;
                    if (response.data.status === 'success') {
                        this.loadSettlementStatus();
                    } else {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.shareTakenSaving = false;
                    this.alert_type = 'Warning';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        formatAmt(v) {
            const n = Number(v);
            return Number.isFinite(n) ? n.toFixed(2) : '0.00';
        },
        // Request Share Fund — copied from BookTakeBack.vue's openRequestShareModal()/
        // submitShareFundRequest() so the dashboard button can act without navigating away.
        openRequestShareModal() {
            this.requestShareAmount = this.settlementStatus && this.settlementStatus.shortfall > 0
                ? this.settlementStatus.shortfall.toFixed(2)
                : '';
            this.requestShareReason = '';
            this.requestShareMsg = '';
            this.requestSharePaymentMethod = 'upi';
            this.requestShareUpiId = '';
            this.requestShareGpayMobile = '';
            this.requestShareGpayName = '';
            this.requestShareAccountHolderName = '';
            this.requestShareAccountNumber = '';
            this.requestShareIfscCode = '';
            $('#requestShareFundModal').modal('show');
        },
        submitShareFundRequest() {
            const amount = parseFloat(this.requestShareAmount);
            if (!amount || amount <= 0) {
                this.requestShareMsg = 'സാധുവായ തുക നൽകുക.';
                return;
            }
            if (this.requestSharePaymentMethod === 'upi' && !this.requestShareUpiId.trim()
                && (!this.requestShareGpayMobile.trim() || !this.requestShareGpayName.trim())) {
                this.requestShareMsg = 'UPI ഐഡി അല്ലെങ്കിൽ ഗൂഗിൾ പേ നമ്പറും പേരും നൽകുക.';
                return;
            }
            if (this.requestSharePaymentMethod === 'bank'
                && (!this.requestShareAccountHolderName.trim() || !this.requestShareAccountNumber.trim() || !this.requestShareIfscCode.trim())) {
                this.requestShareMsg = 'അക്കൗണ്ട് വിവരങ്ങൾ പൂർണ്ണമായി നൽകുക.';
                return;
            }
            this.requestShareSaving = true;
            this.requestShareMsg = '';
            UserService.authPostRequest('request-share-fund-from-state', {
                requesting_level: this.user_level,
                requesting_level_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                amount,
                reason: this.requestShareReason,
                payment_method: this.requestSharePaymentMethod,
                upi_id: this.requestShareUpiId,
                gpay_mobile: this.requestShareGpayMobile,
                gpay_account_holder_name: this.requestShareGpayName,
                account_holder_name: this.requestShareAccountHolderName,
                account_number: this.requestShareAccountNumber,
                ifsc_code: this.requestShareIfscCode,
            }).then(
                (response) => {
                    this.requestShareSaving = false;
                    if (response.data.status === 'success') {
                        $('#requestShareFundModal').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loadMyShareRequestStatus();
                    } else {
                        this.requestShareMsg = response.data.message;
                    }
                },
                (error) => {
                    this.requestShareSaving = false;
                    this.requestShareMsg = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                }
            );
        },
        openVisitModal(type) {
            this.visitModalType = type;
            this.visitModalList = type === 'to_meet' ? this.toMeetList : this.metList;
            $('#visitCountsModal').modal('show');
        },
        toggleVisit(item, checked) {
            item.visited = checked;
            // Update counts reactively
            this.metCount = this.toMeetList.filter(i => i.visited).length;
            this.metList = this.toMeetList.filter(i => i.visited);

            const data = {
                unit_id: parseInt(this.$route.params.id),
                fund_type: parseInt(this.$route.params.type),
                year: this.listYear,
                source: item.source,
                visited: checked,
            };
            if (item.source === 'karad') {
                data.pledge_id = item.pledge_id;
            } else {
                data.member_id = item.member_id;
                data.name = item.name;
            }
            UserService.authPostRequest('toggle-visit', data);
        },
        loadReceiptBooks(redirectIfEmpty = false) {
            if (!this.is_youth_dawa_fund) {
                this.receiptBooks = [];
                return;
            }
            UserService.authPostRequest('receipt-book/list', {
                fund_type: parseInt(this.$route.params.type),
                level: 4,
                id: parseInt(this.$route.params.id),
            }).then((response) => {
                if (response.data.status === 'success') {
                    let books = response.data.data.books || [];
                    if (this.bookId) {
                        // Arrived via a single-book link — show only that book, regardless of admin level
                        books = books.filter(b => b.id == this.bookId);
                    } else if (parseInt(this.currentUser.user_level) >= 5) {
                        // Only regular members (user_level >= 5) get filtered to their own assigned book.
                        // Admins (levels 1–4) always see all books on the unit page.
                        const myMemberId = this.currentUser.member_id;
                        if (myMemberId) {
                            books = books.filter(b => b.holder_member_id == myMemberId);
                        }
                        // On initial page load, redirect back if no book is assigned to this member
                        if (!books.length && redirectIfEmpty) {
                            this.$router.replace('/org');
                            return;
                        }
                    }
                    this.receiptBooks = books;
                }
            });
        },
        openBookTimeline(book) {
            this.timeline_book = book;
            this.timeline_entries = [];
            this.timeline_loading = true;
            $('#bookTimelineModal').modal('show');
            UserService.authPostRequest('receipt-book/timeline', {
                id: book.id,
                fund_type: this.$route.params.type,
                year: this.listYear,
            }).then((response) => {
                this.timeline_loading = false;
                if (response.data.status === 'success') {
                    this.timeline_entries = response.data.data.timeline || [];
                    if (response.data.data.book) {
                        this.timeline_book = { ...this.timeline_book, ...response.data.data.book };
                    }
                }
            }).catch(() => { this.timeline_loading = false; });
        },
        loadAvailableReceiptNumbers(currentNo = null, editableId = null) {
            if (!this.is_youth_dawa_fund) {
                this.availableReceiptNumbers = [];
                return;
            }
            const data = {
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
            };
            if (currentNo) {
                // Editing an existing entry (e.g. a "T..." office-verified one) should offer
                // every available number across all of this unit's books, not just the one the
                // page's own ?book_id happens to be scoped to (that query param is for the
                // "add new" context, not for reassigning an existing entry's receipt number).
                data.current_receipt_no = currentNo;
                if (editableId) {
                    // Lets the backend exclude THIS row (by id) from the "already used" set,
                    // instead of just re-adding the raw number back — which would incorrectly
                    // free up a number actually used by a different entry that happens to share
                    // the same digits (e.g. a "T123" office entry vs a plain "123" manual entry).
                    data.editable_id = editableId;
                }
            } else if (this.bookId) {
                data.book_id = this.bookId;
            }
            UserService.authPostRequest('receipt-book/available-receipt-numbers', data).then((response) => {
                if (response.data.status === 'success') {
                    this.availableReceiptNumbers = response.data.data.numbers || [];
                }
            });
        },
        markBookReceivedConfirmation(book) {
            this.receiveBook_id = book.id;
            this.receiveBook_number = book.book_number;
            this.receiveBook_from = book.receipt_from || '';
            this.receiveBook_to = book.receipt_to || '';
            this.receiveBook_holder = book.holder_name || '';
            this.receiveBook_member_id = book.holder_member_id || null;
            this.receiveBook_search = '';
            this.receiveBook_selected = book.holder_name ? { name: book.holder_name, mobile: '' } : null;
            this.receiveBook_results = [];
            $('#receiveBookModal').modal('show');
        },
        searchReceiveBookMember() {
            clearTimeout(this.receiveBook_timer);
            if (!this.receiveBook_search || this.receiveBook_search.length < 2) {
                this.receiveBook_results = [];
                return;
            }
            this.receiveBook_searching = true;
            this.receiveBook_timer = setTimeout(() => {
                UserService.authGetRequest('members/search', {
                    search: this.receiveBook_search,
                    unit_id: parseInt(this.$route.params.id),
                }).then((response) => {
                    this.receiveBook_searching = false;
                    this.receiveBook_results = response.data.data?.list || [];
                }).catch(() => { this.receiveBook_searching = false; });
            }, 400);
        },
        submitMarkBookReceived() {
            if (this.receiveBook_saving) return;
            this.receiveBook_saving = true;
            UserService.authPostRequest('receipt-book/mark-received', {
                id: this.receiveBook_id,
                holder_name: this.receiveBook_holder || undefined,
                holder_member_id: this.receiveBook_selected?.id || this.receiveBook_member_id || undefined,
            }).then(
                (response) => {
                    this.receiveBook_saving = false;
                    $('#receiveBookModal').modal('hide');
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loadReceiptBooks();
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.receiveBook_saving = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        openChangeHolderModal(book) {
            this.changeHolder_id = book.id;
            this.changeHolder_number = book.book_number;
            this.changeHolder_name = book.holder_name || '';
            this.changeHolder_search = '';
            this.changeHolder_selected = book.holder_name ? { name: book.holder_name, mobile: '' } : null;
            this.changeHolder_results = [];
            $('#changeHolderModal').modal('show');
        },
        searchChangeHolderMember() {
            clearTimeout(this.changeHolder_timer);
            if (!this.changeHolder_search || this.changeHolder_search.length < 2) {
                this.changeHolder_results = [];
                return;
            }
            this.changeHolder_searching = true;
            this.changeHolder_timer = setTimeout(() => {
                UserService.authGetRequest('members/search', {
                    search: this.changeHolder_search,
                    unit_id: parseInt(this.$route.params.id),
                }).then((response) => {
                    this.changeHolder_searching = false;
                    this.changeHolder_results = response.data.data?.list || [];
                }).catch(() => { this.changeHolder_searching = false; });
            }, 400);
        },
        submitChangeHolder() {
            if (this.changeHolder_saving || !this.changeHolder_name) return;
            this.changeHolder_saving = true;
            UserService.authPostRequest('receipt-book/update', {
                id: this.changeHolder_id,
                holder_name: this.changeHolder_name,
                holder_member_id: this.changeHolder_selected?.id || undefined,
            }).then(
                (response) => {
                    this.changeHolder_saving = false;
                    $('#changeHolderModal').modal('hide');
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = 'ചുമതലക്കാരനെ മാറ്റി. ബുക്ക് വീണ്ടും accept ചെയ്യണം.';
                        this.$refs.alert_model.openModel();
                        this.loadReceiptBooks();
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.changeHolder_saving = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        showOldList() {
            this.listYear = this.currentYear - 1;
            this.getMembersList(1);
        },
        showCurrentList() {
            this.listYear = this.currentYear;
            this.getMembersList(1);
        },
        getMembersList(page = 1) {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.listYear
            }
            if (this.bookId) {
                data.book_id = this.bookId;
            }
            UserService.authPostRequest(`get-fund-collections?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.permissions = response.data.data.permissions;
                        this.district_eligible = response.data.data.district_eligible;
                        this.zone_eligible = response.data.data.zone_eligible;
                        this.percentage = response.data.data.percentage;
                        this.is_youth_dawa_fund = response.data.data.is_youth_dawa_fund ?? false;
                        this.member_lists = response.data.data.list;
                        this.selectedBulkIds = [];
                        this.total = response.data.data.total;
                        this.target = response.data.data.target;
                        this.fundCollection = response.data.data.fund_collection ?? this.fundCollection;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list.data;
                        this.unit = response.data.data.unit;
                        if (response.data.data.year != null) {
                            this.listYear = response.data.data.year;
                        }
                        this.$root.updateParent(this.unit.page_title);
                        this.loadReceiptBooks(true);
                        this.loadVisitCounts();
                        if (this.is_youth_dawa_fund) {
                            this.loadSettlementStatus();
                            this.loadMyShareRequestStatus();
                        }
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        disableAddConfirmation() {
            const data = {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.currentYear,
            };
            this.dialog_action_params = data;
            this.dialog_message = 'Target achieved. ഇനി Add ഓഫ് ചെയ്യണോ?';
            this.dialog_action = 'disableAdd';
            this.$refs.dialog_model.openModel();
        },
        disableAdd(data) {
            UserService.authPostRequest('set-fund-collection-add-disabled', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = 'Add button disabled.';
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1);
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        openWhatsApp(item) {
            const mobile = (item.mobile || '').replace(/\D/g, '');
            if (!mobile) return;
            const number = mobile.startsWith('91') ? mobile : '91' + mobile;
            const msg = encodeURIComponent(
                'اَلسَّلاَمُ عَلَيْكُمْ ' + (item.name || '') + ',\n\n' +
                'വിസ്‌ഡം യൂത്ത് ദഅ്‌വ ഫണ്ടിലേക്ക് ₹' + (item.amount || '') + ' ഓൺലൈൻ ആയി അടച്ചതിന് നന്ദി.\n' +
                'Receipt: ' + (item.reciept_no || '') + '\n\n' +
                'جزاك الله خيرا'
            );
            setTimeout(() => window.open('https://wa.me/' + number + '?text=' + msg, '_blank'), 300);
        },
        payStateShare() {
            const amount = this.stateShareAmount;
            if (!amount || amount <= 0) {
                this.alert_type = 'Warning';
                this.alert_message = 'Invalid amount.';
                this.$refs.alert_model.openModel();
                return;
            }
            const data = {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.currentYear,
                amount: amount,
            };
            UserService.authPostRequest('mark-fund-collection-state-payment-started', data).finally(() => {
                const url = new URL('https://www.donate.wisdomislam.org/working-fund');
                url.searchParams.set('amount', amount.toFixed(2));
                url.searchParams.set('note', 'സ്റ്റേറ്റ് വിഹിതം');
                url.searchParams.set('unit_id', String(this.$route.params.id));
                window.open(url.toString(), '_blank');
                this.getMembersList(1);
            });
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

/* ===== Book Taking Back nav card (same design as the zone report page) ===== */
.ydf-takeback-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 14px;
    padding: 12px 14px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .05);
    text-decoration: none;
    transition: transform .12s ease, box-shadow .12s ease;
}
.ydf-takeback-btn:active {
    transform: translateY(1px);
    box-shadow: 0 1px 5px rgba(0, 0, 0, .06);
}
button.ydf-takeback-btn {
    width: 100%;
    text-align: left;
    cursor: pointer;
}
.ydf-takeback-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 21px;
}
.ydf-takeback-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}
.ydf-takeback-title {
    font-size: 14px;
    font-weight: 800;
    color: #27173E;
}
.ydf-takeback-desc {
    font-size: 11px;
    color: #6c757d;
    line-height: 1.35;
    margin-top: 2px;
}
.ydf-takeback-badge {
    display: inline-block;
    align-self: flex-start;
    font-size: 10.5px;
    font-weight: 700;
    border-radius: 20px;
    padding: 3px 8px;
    white-space: normal;
    margin-top: 4px;
    max-width: 100%;
}
.ydf-takeback-badge.badge-accepted { background: #eafaf1; color: #12a85a; }
.ydf-takeback-badge.badge-pending { background: #fff8e1; color: #b45309; }
.ydf-takeback-badge.badge-rejected { background: #fff5f5; color: #d9534f; }
.ydf-takeback-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}

/* Mark Share Taken status card — same design as HighLevelReport.vue's settlement cards. */
.share-taken-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 14px;
    padding: 12px 14px;
}
.share-taken-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #dcfce7;
    color: #16a34a;
    font-size: 21px;
}
.share-taken-card.status-pending {
    background: #fffbeb;
    border-color: #fde68a;
}
.share-taken-card.status-pending .share-taken-icon {
    background: #fef3c7;
    color: #b45309;
}
.share-taken-card.status-rejected {
    background: #fef2f2;
    border-color: #fecaca;
}
.share-taken-card.status-rejected .share-taken-icon {
    background: #fee2e2;
    color: #dc2626;
}

/* ── Help Desk card ───────────────────────────────────────────── */
.helpdesk-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 8px 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,.04);
}
.helpdesk-left { display: flex; align-items: center; gap: 7px; min-width: 0; }
.helpdesk-icon { font-size: 20px; color: #1a418c; flex-shrink: 0; }
.helpdesk-title { font-size: 13px; font-weight: 800; color: #27173E; white-space: nowrap; }
.helpdesk-actions { display: flex; gap: 7px; }
.helpdesk-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #fff;
    text-decoration: none;
}
.helpdesk-btn ion-icon { font-size: 18px; }
.helpdesk-btn.call { background: #1a418c; }
.helpdesk-btn.wa { background: #25D366; }

/* ── Office payment form ───────────────────────────────────────── */
.office-toggle {
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    margin-bottom: 16px;
    background: #f8fafc;
    transition: all .2s ease;
}
.office-toggle.active {
    border-color: #f59e0b;
    background: #fff8ef;
}
.office-toggle-row {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    margin: 0;
}
.office-toggle-row input[type="checkbox"] {
    width: 20px;
    height: 20px;
    accent-color: #f59e0b;
    flex-shrink: 0;
}
.office-toggle-text {
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
    flex: 1;
}
.office-toggle-icon {
    font-size: 22px;
    color: #f59e0b;
}
.office-toggle-note {
    display: block;
    margin-top: 8px;
    font-size: 11.5px;
    line-height: 1.5;
    color: #92400e;
}

.office-panel {
    border: 1.5px dashed #fbbf24;
    background: #fffbf3;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 16px;
}
.office-panel-title {
    font-weight: 700;
    font-size: 13px;
    color: #b45309;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.existing-slip-link {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #16a34a;
    margin-bottom: 8px;
}

.upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    min-height: 92px;
    padding: 14px;
    border: 2px dashed #cbd5e1;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    text-align: center;
    transition: all .2s ease;
}
.upload-box:hover { border-color: #f59e0b; background: #fffaf0; }
.upload-box.filled { border-color: #16a34a; border-style: solid; background: #f0fdf4; }
.upload-icon { font-size: 30px; color: #94a3b8; }
.upload-box.filled .upload-icon { color: #16a34a; }
.upload-text {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    line-height: 1.4;
}
.upload-text small {
    display: block;
    font-weight: 400;
    font-size: 11px;
    color: #94a3b8;
    margin-top: 2px;
}
.upload-text.filled-text { color: #15803d; word-break: break-all; }
.upload-text.filled-text small { color: #4ade80; }

.office-or {
    text-align: center;
    margin: 12px 0;
    position: relative;
}
.office-or::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #fde0a8;
}
.office-or span {
    position: relative;
    background: #fffbf3;
    padding: 0 12px;
    font-size: 11px;
    color: #b45309;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.office-panel .input-wrapper .label em {
    font-style: normal;
    color: #94a3b8;
    font-weight: 400;
}

.error-feedback {
    color: red;
}

.listview {
    margin-bottom: 0;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.list-actions-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.list-actions-left,
.list-actions-right {
    display: flex;
    align-items: center;
}

.list-actions-right .btn {
    white-space: nowrap;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.pagination-container {
    display: flex;
    column-gap: 10px;
}

.paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #3498db;
    border: 1px solid #3498db;
    color: white;
}

.active-page:hover {
    background-color: #2988c8;
}

/* Receipt Book Cards */
.receipt-book-grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.receipt-book-card {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.07);
    border-left: 3px solid #ccc;
}

.receipt-book-card.received {
    border-left-color: #22c55e;
    background: #f0fdf4;
}

.receipt-book-card.pending {
    border-left-color: #f59e0b;
    background: #fffbeb;
}

/* Row 1: icon + title/range + status button */
.rb-row1 {
    display: flex;
    align-items: center;
    gap: 8px;
}

.rb-icon {
    font-size: 20px;
    color: #1a418c;
    flex-shrink: 0;
}

.rb-info {
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex: 1;
    min-width: 0;
}

.rb-title {
    font-weight: 700;
    font-size: 14px;
    color: #1e293b;
    white-space: nowrap;
}

.rb-range {
    font-size: 11px;
    color: #64748b;
    white-space: nowrap;
}

/* Row 2: holder pill — full width */
.rb-holder {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #1a418c;
    background: #eef3ff;
    border: 1px solid #d0dbff;
    border-radius: 8px;
    padding: 5px 12px;
}

.rb-holder ion-icon {
    font-size: 14px;
    flex-shrink: 0;
}

.rb-badge.received-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #22c55e;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 9px;
    border-radius: 20px;
}

.rb-badge.received-badge ion-icon {
    font-size: 12px;
}

.rb-receive-btn {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #1a418c;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    border: none;
    cursor: pointer;
    white-space: nowrap;
}

.rb-receive-btn ion-icon {
    font-size: 12px;
}

.rb-receive-btn:active {
    background: #122d61;
}

.rb-timeline-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    background: #f0f0ff;
    color: #6366f1;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 0;
}

.rb-timeline-btn ion-icon {
    font-size: 15px;
}

.rb-timeline-btn:active {
    background: #e0e0ff;
}

.rb-edit-holder-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid #a5b4fc;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    padding: 0;
    cursor: pointer;
    color: #4f46e5;
    flex-shrink: 0;
    margin-left: auto;
}

.rb-edit-holder-btn ion-icon {
    font-size: 13px;
}

.rb-edit-holder-btn:active {
    background: #e0e7ff;
}

.rb-header {
    margin-bottom: 6px;
}

.rb-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

/* ===== Bulk "send branch's held amount to State account" ===== */
.ydf-bulk-entry-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    border: none;
    background: linear-gradient(135deg, #1a418c, #2a63c9);
    color: #fff;
    padding: 12px 14px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
    text-align: left;
    box-shadow: 0 3px 10px rgba(26, 65, 140, 0.22);
}

.ydf-bulk-entry-btn ion-icon {
    font-size: 20px;
    flex-shrink: 0;
}

.ydf-bulk-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
}

.ydf-bulk-header-title {
    font-size: 15px;
    font-weight: 700;
}

/* Match the main donor list's row density — the Manual list has one fewer
   text line (no source badge), which was making its avatar/name look
   oversized by comparison even though the row markup is otherwise identical. */
.ydf-manual-listview .avatar-section .image {
    width: 32px;
    height: 32px;
    margin-right: 12px;
}

.ydf-manual-listview b {
    font-size: 14px;
}

.ydf-manual-listview .sl-no {
    font-size: 13px;
}

/* .listview.inset adds its own 16px side margins on top of the parent .section's
   16px padding, making this list narrower than the payment card / select-all row
   above it (which only get the section's padding). Zero it out so all three align. */
.ydf-manual-listview.inset {
    margin-left: 0;
    margin-right: 0;
}

.ydf-select-all {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 12px;
    margin-top: 10px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dde3ea;
    border-radius: 10px;
    color: #26324a;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.ydf-select-all span {
    font-size: 12.5px;
    font-weight: 600;
}

.ydf-bulk-amount-bar {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    background: linear-gradient(160deg, #1fa055, #17c58a);
    color: #fff;
    padding: 18px 16px;
    border-radius: 16px;
    max-width: 100%;
    box-sizing: border-box;
    box-shadow: 0 6px 16px rgba(23, 160, 100, 0.25);
}

.ydf-bulk-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.22);
}

.ydf-bulk-count {
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.03em;
    opacity: 0.85;
    text-transform: uppercase;
}

.ydf-bulk-amount {
    font-size: 26px;
    font-weight: 800;
    letter-spacing: 0.01em;
}

.ydf-bulk-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.ydf-upi-choose-label {
    margin: 0;
    font-size: 12.5px;
    font-weight: 500;
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
}

.ydf-upi-id-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background: #fff;
    color: #26324a;
    padding: 10px 12px;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.ydf-upi-id-text {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.01em;
    overflow-wrap: anywhere;
}

.ydf-gpay-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    background: #fff;
    color: #4285f4;
    padding: 10px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.ydf-gpay-btn ion-icon {
    font-size: 18px;
}

.ydf-upi-copy-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    border: none;
    background: #1a418c;
    color: #fff;
    padding: 7px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
}

.ydf-upi-copy-btn ion-icon {
    font-size: 15px;
}

.ydf-bulk-note {
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
}

.ydf-bulk-btn {
    border: 1.5px solid rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    padding: 11px 12px;
    border-radius: 12px;
    font-size: 12.5px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    white-space: normal;
    width: 100%;
}

.ydf-bulk-btn ion-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.ydf-bulk-btn:disabled {
    opacity: 0.6;
}

.ydf-row-check {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    flex-shrink: 0;
    cursor: pointer;
}
</style>